/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

var Utils =
/** @class */
function () {
  function Utils() {
    this.appKeys = {
      relative_old: 'valor relativo',
      relative: 'relative',
      absolute_old: 'valor absoluto',
      absolute: 'absolut'
    };
    this.inputTypes = [{
      type: 'integer',
      operators: [{
        name: 'Maior igual a ( >= )',
        value: '>='
      }, {
        name: 'Maior que ( > )',
        value: '>'
      }, {
        name: 'Menor igual a ( <= )',
        value: '<='
      }, {
        name: 'Menor que ( < )',
        value: '<'
      }, {
        name: 'Igual a ( = )',
        value: '='
      }, {
        name: 'Intervalo ( 10,20 )',
        value: 'i'
      }, {
        name: 'Diferente de',
        value: '!='
      }]
    }, {
      type: 'string',
      operators: [{
        name: 'Igual a ( = )',
        value: '='
      }, {
        name: 'Diferente de',
        value: '!='
      }]
    }, {
      type: 'date',
      operators: [{
        name: 'Maior igual a ( >= )',
        value: '>='
      }, {
        name: 'Maior que ( > )',
        value: '>'
      }, {
        name: 'Menor igual a ( <= )',
        value: '<='
      }, {
        name: 'Menor que ( < )',
        value: '<'
      }]
    }];
    this.specialInputs = [{
      id: '*asdcb4-asd-asd-asdadadasd',
      name: 'ID time',
      type: 'string',
      jsonMap: 'includesTeam',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }];
    this.indicatorsInputs = [{
      id: 'aa9c0045-210a-4117-8f9c-ff1a62385b67',
      name: '[Indices total] - Chutes perigosos casa',
      type: 'integer',
      jsonMap: 'indicators.chutesPerigososCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '088e83c5-49d8-4251-9cc8-22dab7453fcb',
      name: '[Indices total] - Eficiencia casa',
      type: 'integer',
      jsonMap: 'indicators.eficienciaCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'f847efd0-426f-468b-b91c-610cbb969c38',
      name: '[Indices total] - Volume ofensivo casa - N1',
      type: 'integer',
      jsonMap: 'indicators.n1Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '6f44012e-ec54-4c55-841f-c3d0805bb174',
      name: '[Indices total] - Volume ofensivo casa - N2',
      type: 'integer',
      jsonMap: 'indicators.n2Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '7aaa9a98-1de3-4c97-b4a4-39e4129e7937',
      name: '[Indices total] - Volume ofensivo casa - N3',
      type: 'integer',
      jsonMap: 'indicators.n3Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '4d127df4-507b-4d54-8f55-b86539149dee',
      name: '[Indices total] - Volume ofensivo casa - N4',
      type: 'integer',
      jsonMap: 'indicators.n4Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'b02d6852-6ebf-49de-ad75-de06c4ea5100',
      name: '[Indices total] - Volume ofensivo casa - N5',
      type: 'integer',
      jsonMap: 'indicators.n5Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '81991913-f80f-4eed-b047-9bca4fa2051e',
      name: '[Indices total] - Pressão casa',
      type: 'integer',
      jsonMap: 'indicators.pCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '91be6f84-a3b2-4460-b8e1-650884655f46',
      name: '[Indices total] - PC casa',
      type: 'integer',
      jsonMap: 'indicators.pcCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'b0256110-de4b-43da-9cf4-d5dc067469f3',
      name: '[Indices total] - PE casa',
      type: 'integer',
      jsonMap: 'indicators.peCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'aff98e1d-7aa7-41a7-adcd-7c6b97fecaf7',
      name: '[Indices total] - PEX casa',
      type: 'integer',
      jsonMap: 'indicators.pexCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '700e42d0-0d73-460a-9ebb-15108ee6462b',
      name: '[Indices total] - PR casa',
      type: 'integer',
      jsonMap: 'indicators.prCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '34ceeb4a-d617-411e-9170-8b9756cfdf93',
      name: '[Indices total] - PV casa',
      type: 'integer',
      jsonMap: 'indicators.pvCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'f266047e-cc16-4c35-892e-73dc7cb2b1b1',
      name: '[Indices total] - Chutes perigosos visitante',
      type: 'integer',
      jsonMap: 'indicators.chutesPerigososVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'f3a72780-fb0b-45e1-83be-b462138fecda',
      name: '[Indices total] - Eficiencia visitante',
      type: 'integer',
      jsonMap: 'indicators.eficienciaVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '4dffbc76-82da-4ab9-9f7b-c5bb454c92c1',
      name: '[Indices total] - Volume ofensivo visitante - N1',
      type: 'integer',
      jsonMap: 'indicators.n1Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '9292464a-7e44-4eb8-b1f8-bfcfae6f111c',
      name: '[Indices total] - Volume ofensivo visitante - N2',
      type: 'integer',
      jsonMap: 'indicators.n2Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '288f2ad3-d85f-4966-a26a-602be4f45c04',
      name: '[Indices total] - Volume ofensivo visitante - N3',
      type: 'integer',
      jsonMap: 'indicators.n3Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '2f58cfaa-856b-4cae-88f9-b5cbe89659d8',
      name: '[Indices total] - Volume ofensivo visitante - N4',
      type: 'integer',
      jsonMap: 'indicators.n4Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '46a437d2-d3f3-4fa5-8bac-7b4463d66f97',
      name: '[Indices total] - Volume ofensivo visitante - N5',
      type: 'integer',
      jsonMap: 'indicators.n5Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '3dccadb6-5ea7-439f-a819-8284138393d2',
      name: '[Indices total] - Pressão visitante',
      type: 'integer',
      jsonMap: 'indicators.pVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '8de569ce-c187-4a7d-83fe-75c732abec32',
      name: '[Indices total] - PC visitante',
      type: 'integer',
      jsonMap: 'indicators.pcVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '56c6cef4-b194-4201-86bf-dff6f6c59764',
      name: '[Indices total] - PE visitante',
      type: 'integer',
      jsonMap: 'indicators.peVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '4233a35c-632b-42f2-8974-f9832e97c82a',
      name: '[Indices total] - PEX visitante',
      type: 'integer',
      jsonMap: 'indicators.pexVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '9b7af7da-ceed-4c0c-ad32-4380535c16a6',
      name: '[Indices total] - PR visitante',
      type: 'integer',
      jsonMap: 'indicators.prVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '0f432efd-0ffe-42f5-b1d3-66fabb48a360',
      name: '[Indices total] - PV visitante',
      type: 'integer',
      jsonMap: 'indicators.pvVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, // INDICATORS 10
    {
      id: '82fc171e-6273-476e-86d9-1d3647d79c33',
      name: '[Indices 10min] - Chutes perigosos casa',
      type: 'integer',
      jsonMap: 'indicators10.chutesPerigososCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'a53b5d7c-18d8-4584-b5cb-6a7ab4031804',
      name: '[Indices 10min] - Eficiencia casa',
      type: 'integer',
      jsonMap: 'indicators10.eficienciaCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '5c8dc33e-29d8-46c0-8c4e-d601741f12f8',
      name: '[Indices 10min] - Volume ofensivo casa - N1',
      type: 'integer',
      jsonMap: 'indicators10.n1Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'ad62c68f-fa21-4863-8610-9db3a17bb448',
      name: '[Indices 10min] - Volume ofensivo casa - N2',
      type: 'integer',
      jsonMap: 'indicators10.n2Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '84220b27-bfa2-4fa2-a756-cd455ea0758c',
      name: '[Indices 10min] - Volume ofensivo casa - N3',
      type: 'integer',
      jsonMap: 'indicators10.n3Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'dabc1655-3c99-439f-8495-2e7eec34bc87',
      name: '[Indices 10min] - Volume ofensivo casa - N4',
      type: 'integer',
      jsonMap: 'indicators10.n4Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'd921d624-65df-4036-a8d1-a6e095284fe5',
      name: '[Indices 10min] - Volume ofensivo casa - N5',
      type: 'integer',
      jsonMap: 'indicators10.n5Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '267dacb4-7aaf-42c6-9e18-54ad4c6905a2',
      name: '[Indices 10min] - Pressão casa',
      type: 'integer',
      jsonMap: 'indicators10.pCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'b6897a10-f39c-47c8-8506-9ebe0a0b195b',
      name: '[Indices 10min] - PC casa',
      type: 'integer',
      jsonMap: 'indicators10.pcCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '94c5ef02-2f1a-4d6a-a717-4b58bde4eb40',
      name: '[Indices 10min] - PE casa',
      type: 'integer',
      jsonMap: 'indicators10.peCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '4d2ff843-61d4-43c3-8ccb-38cee7ab7170',
      name: '[Indices 10min] - PEX casa',
      type: 'integer',
      jsonMap: 'indicators10.pexCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'c00ec083-6289-4cba-941a-cc8427a3cc5c',
      name: '[Indices 10min] - PR casa',
      type: 'integer',
      jsonMap: 'indicators10.prCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'c342ca7c-94cd-4c99-a0b8-8a229fbb86f8',
      name: '[Indices 10min] - PV casa',
      type: 'integer',
      jsonMap: 'indicators10.pvCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '9299d333-006d-496f-ba6e-2458016e9212',
      name: '[Indices 10min] - Chutes perigosos visitante',
      type: 'integer',
      jsonMap: 'indicators10.chutesPerigososVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '04df83e4-9fb6-4025-8ce8-1bc7c9c8281e',
      name: '[Indices 10min] - Eficiencia visitante',
      type: 'integer',
      jsonMap: 'indicators10.eficienciaVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '39f66971-e08d-4ee8-a114-f4547968bbe5',
      name: '[Indices 10min] - Volume ofensivo visitante - N1',
      type: 'integer',
      jsonMap: 'indicators10.n1Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '30bfe513-cc3d-4784-b535-c84c35505305',
      name: '[Indices 10min] - Volume ofensivo visitante - N2',
      type: 'integer',
      jsonMap: 'indicators10.n2Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '273c30e1-9d46-46bf-8898-e87dae630732',
      name: '[Indices 10min] - Volume ofensivo visitante - N3',
      type: 'integer',
      jsonMap: 'indicators10.n3Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'c784816b-81db-4ca2-93fa-0b0cfa9d8419',
      name: '[Indices 10min] - Volume ofensivo visitante - N4',
      type: 'integer',
      jsonMap: 'indicators10.n4Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '3a9e83ae-7e14-45a1-a4bf-f3049b438bef',
      name: '[Indices 10min] - Volume ofensivo visitante - N5',
      type: 'integer',
      jsonMap: 'indicators10.n5Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'c8cc1d0c-9041-460e-a434-f73c474eeb91',
      name: '[Indices 10min] - Pressão visitante',
      type: 'integer',
      jsonMap: 'indicators10.pVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'e7b6f9ff-fe6e-44b1-a571-88ae7519bd01',
      name: '[Indices 10min] - PC visitante',
      type: 'integer',
      jsonMap: 'indicators10.pcVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '44ca7681-5543-42a4-8b18-eec6cfaa989a',
      name: '[Indices 10min] - PE visitante',
      type: 'integer',
      jsonMap: 'indicators10.peVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '2cf02349-a570-4c34-b3e0-47dab015fe89',
      name: '[Indices 10min] - PEX visitante',
      type: 'integer',
      jsonMap: 'indicators10.pexVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: '4353c767-200c-4412-b86e-12106f3134fa',
      name: '[Indices 10min] - PR visitante',
      type: 'integer',
      jsonMap: 'indicators10.prVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, {
      id: 'c46c71c5-29b0-4d42-a6fd-215e4c2ca4da',
      name: '[Indices 10min] - PV visitante',
      type: 'integer',
      jsonMap: 'indicators10.pvVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112],
      inputAccess: [1]
    }, // CESAR INDICATORS
    {
      id: 'c46c71c5-26fd123ss1234da',
      name: 'Cesar - John',
      type: 'integer',
      jsonMap: 'cesarIndicators.john',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c4-26fd123ss123s12334da',
      name: 'Cesar - Bobby',
      type: 'integer',
      jsonMap: 'cesarIndicators.bobby',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c471c5-26fd1qs87s98714da',
      name: 'Cesar - Castiel',
      type: 'integer',
      jsonMap: 'cesarIndicators.castiel',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46cc5-26f12387asd89123s4da',
      name: 'Cesar - CompOver',
      type: 'integer',
      jsonMap: 'cesarIndicators.compOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46cc5-26f12387asd89123s4da12312',
      name: 'Cesar - Aceleração1',
      type: 'integer',
      jsonMap: 'cesarIndicators.aceleracao1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46cc5-26f12387asd89123s4da123123',
      name: 'Cesar - Aceleração2',
      type: 'integer',
      jsonMap: 'cesarIndicators.aceleracao2',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46cc5-26f12387asd89123s4da1231234',
      name: 'Cesar - AceleraçãoBaixa',
      type: 'integer',
      jsonMap: 'cesarIndicators.aceleracaoBaixa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46cc5-26f12387asd89123s4da12312345',
      name: 'Cesar - HunterHT',
      type: 'integer',
      jsonMap: 'cesarIndicators.hunterHt',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, // GUERRA INDICATORS
    {
      id: 'c46c71c5-2123sda1239878899234da',
      name: 'Guerra - robozao',
      type: 'integer',
      jsonMap: 'guerraIndicators.robozao',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c4-26fd123ss123s123123123412312334da',
      name: 'Guerra - robozao2',
      type: 'integer',
      jsonMap: 'guerraIndicators.robozao2',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c471c5-27s12312412341239o98714da',
      name: 'Guerra - thoor',
      type: 'integer',
      jsonMap: 'guerraIndicators.thoor',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c471c5-27asdjkldajdk12387asdlk123aaasdasdada',
      name: 'Guerra - apollo',
      type: 'integer',
      jsonMap: 'guerraIndicators.apollo',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c471c5-27asdjkldajdk12387asdlk123aaa2131123ada',
      name: 'Guerra - Alien HT',
      type: 'integer',
      jsonMap: 'guerraIndicators.allienHT',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c471c5-27asdjkldajdk12387a12387',
      name: 'Guerra - Abdutor',
      type: 'integer',
      jsonMap: 'guerraIndicators.abdutor',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c471c5-27asdjkldajdk12387a12381353',
      name: 'Guerra - UhPapaiChegou',
      type: 'integer',
      jsonMap: 'guerraIndicators.uhpapaiChegou',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, // FULLTIPS INDICATORS
    {
      id: 'c46c71c5-212asdjlkq2jkl3a98123891',
      name: 'Fulltips - Over',
      type: 'integer',
      jsonMap: 'fulltipsIndicators.fulltipsOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq38912341234da2',
      name: 'FtUtilidades - Negar amistosos',
      type: 'integer',
      jsonMap: 'ftUtilsIndicators.negarAmistosos',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl234da3',
      name: 'FtUtilidades - Jogo sem dados',
      type: 'integer',
      jsonMap: 'ftUtilsIndicators.jogosSemDados',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a94',
      name: 'FtUtilidades - Gold com dados',
      type: 'integer',
      jsonMap: 'ftUtilsIndicators.goldComDados',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a95',
      name: 'FtUtilidades - Silver com dados',
      type: 'integer',
      jsonMap: 'ftUtilsIndicators.silverComDados',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdj11',
      name: 'FtUtilidades - Negar copas',
      type: 'integer',
      jsonMap: 'ftUtilsIndicators.negarCopasAmistoso',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a9812386',
      name: 'FtLive - Comportamento over',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.compOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212askq2jkl7',
      name: 'FtLive - Momento over',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.momOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq8',
      name: 'FtLive - Gatilho over',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.gatOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a9',
      name: 'FtLive - Monitorar over',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.moniOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjl10',
      name: 'FtLive - Aceleração over',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.aceleracaoOver',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c711231234123c5-212asdjl10',
      name: 'FtLive - Penitenciaria MO Casa',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.penitenciariaMOCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c7123451231c5-212asdjl10',
      name: 'FtLive - Penitenciaria MO Visitante',
      type: 'integer',
      jsonMap: 'ftLiveIndicators.penitenciariaMOVisitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asd121asd123jl10123',
      name: 'Fulltips - Over HT 1',
      type: 'integer',
      jsonMap: 'fulltipsIndicators.fullTipsOverHT1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjl10123321123',
      name: 'Fulltips - Over Limite FT 1',
      type: 'integer',
      jsonMap: 'fulltipsIndicators.fullTipsOverLimiteFT1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, // ALEX INDICATORS
    {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda1',
      name: 'Alex - Bandolero 1 Casa',
      type: 'integer',
      jsonMap: 'alexIndicators.bandolero1Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda2',
      name: 'Alex - Bandolero 2 Casa',
      type: 'integer',
      jsonMap: 'alexIndicators.bandolero2Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda3',
      name: 'Alex - Bandolero 1 Visitante',
      type: 'integer',
      jsonMap: 'alexIndicators.bandolero1Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda4',
      name: 'Alex - Bandolero 2 Visitante',
      type: 'integer',
      jsonMap: 'alexIndicators.bandolero2Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda4123',
      name: 'Alex - Bandolero perde vantagem casa - Casa',
      type: 'integer',
      jsonMap: 'alexIndicators.bandoleroPVantaCasaCasa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda41232',
      name: 'Alex - Bandolero perde vantagem casa - Total',
      type: 'integer',
      jsonMap: 'alexIndicators.bandoleroPVantaCasaTotal',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda41233',
      name: 'Alex - Bandolero perde vantagem fora - Fora',
      type: 'integer',
      jsonMap: 'alexIndicators.bandoleroPVantaForaFora',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c46c71c5-212asdjlkq2jkl3a98123aasda41234',
      name: 'Alex - Bandolero perde vantagem fora - Total',
      type: 'integer',
      jsonMap: 'alexIndicators.bandoleroPVantaForaTotal',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }]; // Only dataType market odds / market volume

    this.marketInputs = [{
      id: 'ea3755f5-b7c3-4da3-9515-cc1b7b83c214',
      name: 'Match Odds - Back - Time Casa',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'fc8ec18e-43f8-4824-ba97-e438e71615e2',
      name: 'Match Odds - Lay - Time Casa',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'fbaa2c36-5d3a-435f-9709-4331ab4e59a7',
      name: 'Match Odds - Back - Time Visitante ',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'a09af5bd-aaa8-4244-a611-15c7a47ab038',
      name: 'Match Odds - Lay - Time Visitante ',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'e0b0b76c-dcaf-49a1-98b2-7935b2b96014',
      name: 'Match Odds - Back - Empate',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-3\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'd01068d0-ede9-4e89-8ae3-e5aeb1acc09b',
      name: 'Match Odds - Lay - Empate',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-3\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '89850274-df8b-4dd4-95e5-e2cf10aa9e31',
      name: 'Match Odds - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'match odds-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '73229a2d-d02c-4e4a-932b-b0f681e5a24a',
      name: 'Half Time - Back - Time Casa',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'f51f3296-d70d-40f7-8557-879fce8162c8',
      name: 'Half Time - Lay - Time Casa',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '90b5f7ee-bd98-49d2-becb-15b5a9c159d3',
      name: 'Half Time - Back - Time Visitante',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'ca4b07ce-cd55-45c3-acc5-bb78763d40ee',
      name: 'Half Time - Lay - Time Visitante',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '41564aef-2ae0-4f7d-8745-e23ba9def25a',
      name: 'Half Time - Back - Empate',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-3\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '76061b82-b7bf-4e1a-85d6-a1c4be84540b',
      name: 'Half Time - Lay - Empate',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-3\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '69273f33-8032-4d05-b1b8-703655dc0c44',
      name: 'Half Time - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '7a2b0dc7-5036-4828-911a-dde3dc721395',
      name: 'Under 0.5 HT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 0.5-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '00ee57a0-fc77-429b-843d-34456e19c808',
      name: 'Under 0.5 HT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 0.5-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '5e8a6371-81de-425c-b990-ce420bade2e6',
      name: 'Over 0.5 HT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 0.5-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'e0068e8c-660e-4e8b-8c40-3d653752ef0d',
      name: 'Over 0.5 HT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 0.5-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'da9c1cad-4c59-4ec6-9654-ca9bc13e985f',
      name: 'Over 0.5 HT - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 0.5-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'b158e484-7312-486b-a7ae-82b39df7ecb8',
      name: 'Under 1.5 HT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 1.5-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '89f02c6d-4fe6-4f13-8a7f-cb04ab0a2a67',
      name: 'Under 1.5 HT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 1.5-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '0a868808-137b-49fc-a96e-18b1cf3b1920',
      name: 'Over 1.5 HT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 1.5-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '0240bbe7-6817-494f-97d7-71d84b22751f',
      name: 'Over 1.5 HT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 1.5-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'da590a96-cdea-4008-9c5e-22af9eae6c5b',
      name: 'Over 1.5 HT - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 1.5-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'c0318e1c-d90e-4f47-97fe-d70c356d5f0b',
      name: 'Under 2.5 HT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 2.5-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'd1ec0fc0-d18d-420d-82b4-334f94529d57',
      name: 'Under 2.5 HT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 2.5-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'b3cfcd9b-62f9-4a5c-8419-5dd0cf0e3015',
      name: 'Over 2.5 HT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 2.5-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'cc5554aa-4f5f-4a5c-93eb-e951ce5201f5',
      name: 'Over 2.5 HT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 2.5-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '8bebc36e-8203-4df0-941c-3647ec786794',
      name: 'Over 2.5 HT - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'first half goals 2.5-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '56879e39-02fe-47d6-82c8-70bbb7aeb76f',
      name: 'Under 0.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 0.5 goals-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '11bfe55e-cc33-44fe-abad-87bf1bb45096',
      name: 'Under 0.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 0.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '43fd1dc2-1177-4438-a558-c971be21cec7',
      name: 'Over 0.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 0.5 goals-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '838a34d1-2a47-4f75-abbc-1ee980477fbb',
      name: 'Over 0.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 0.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '3f3045e2-3353-4aca-b80c-a1f98c6a78ad',
      name: 'Over 0.5 - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 0.5 goals-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '125d59f8-9485-4787-bdd3-cf43db2cd78d',
      name: 'Under 1.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 1.5 goals-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '39b384f7-e95d-4de5-a049-c011cde20543',
      name: 'Under 1.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 1.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '9ce773ce-d8eb-4ca4-9d91-99d0ca875703',
      name: 'Over 1.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 1.5 goals-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '5793f0bf-6b73-4f27-a230-63684372fc2a',
      name: 'Over 1.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 1.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'edddd694-03e8-4af2-abac-0c0e142358e5',
      name: 'Over 1.5 - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 1.5 goals-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '419f332a-c959-43e2-9ceb-93747a2b1bc7',
      name: 'Under 2.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 2.5 goals-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'e2c4cbe9-d41f-4df4-882b-b497256d5132',
      name: 'Under 2.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 2.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'cbe0e6da-3624-44d9-8483-ee29a172c00e',
      name: 'Over 2.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 2.5 goals-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '67840a68-d25d-42dd-afac-8a5886279467',
      name: 'Over 2.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 2.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'd3001861-6613-446f-a833-bff376a659bc',
      name: 'Over 2.5 - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 2.5 goals-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'a1696310-1111-4a28-becf-e8901a2a026a',
      name: 'Under 3.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 3.5 goals-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '71206a00-2776-453e-968c-efa14254847a',
      name: 'Under 3.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 3.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '8336c7cf-52b4-4a52-bb9b-c0513d902c3b',
      name: 'Over 3.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 3.5 goals-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '7cf18d0c-74c5-4ace-bb11-deeb77f19537',
      name: 'Over 3.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 3.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'ccff54ff-8550-4953-b866-108cb0dbe906',
      name: 'Over 3.5 - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 3.5 goals-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '0d76f45a-619c-4b6e-866b-691a3f051a3f',
      name: 'Under 4.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 4.5 goals-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '9c2501b3-1115-492f-80d7-f0a60260eae8',
      name: 'Under 4.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 4.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '4ed58a7e-6ff1-44a6-aceb-4c54f1e88c22',
      name: 'Over 4.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 4.5 goals-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'c76c83f7-6d91-47b8-bf10-2270c234c806',
      name: 'Over 4.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 4.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '85cf30fa-96d4-4037-bcc7-496815575b45',
      name: 'Over 4.5 - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 4.5 goals-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '16484d43-b10c-4dcb-b2c6-6790585eb668',
      name: 'Under 5.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 5.5 goals-1\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '5d7d081b-113a-40d4-8be7-56a46095eb04',
      name: 'Under 5.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 5.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'e2798de4-ffb1-4e05-a8b1-733c1e06ded0',
      name: 'Over 5.5 - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 5.5 goals-2\'].back',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '4bea6d2a-cd58-4b1d-8ffb-3938aa1f5fa8',
      name: 'Over 5.5 - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 5.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '636cc6c2-34ff-4525-a08c-2231132c8994',
      name: 'Over 5.5 - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'over/under 5.5 goals-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'd793ffd0-ebff-4525-8921-1fc04430f02c',
      name: 'Ambas Marcam Sim - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-1\'].back',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '4cde029f-51c8-47fb-a4c9-b1ec93a29f57',
      name: 'Ambas Marcam Sim - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-1\'].lay',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '616265ae-16d6-4931-a009-9d7d6fee2b84',
      name: 'Ambas Marcam Não - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-2\'].back',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '48bcc516-fa36-4ba7-85a2-88a25c4cca9a',
      name: 'Ambas Marcam Não - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-2\'].lay',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: 'cd188b7f-141b-408d-a10f-9418c1da6d13',
      name: 'Ambas Marcam - Dinheiro mercado',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-1\'].volume',
      dataType: 'market volume',
      access: [9, 8, 7, 15, 111, 112]
    }, {
      id: '7382f59b-a6d0-4782-97b3-47b082d166dd',
      name: 'CS - 0x0 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-1\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '46aca658-62fc-4628-a127-434a7c5a72f5',
      name: 'CS - 0x0 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-1\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '4af8054d-b4c2-4dad-8d4c-e82666f4791a',
      name: 'CS - 0x1 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-2\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '343a0a34-4b04-4fa0-b3f9-1ab9119eb4ad',
      name: 'CS - 0x1 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-2\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '149c88b3-2dad-41fc-b64f-fab5fb059579',
      name: 'CS - 0x2 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-3\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '37bdb8d5-0872-42d0-bcfb-070053f528e0',
      name: 'CS - 0x2 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-3\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'eca641ca-3737-4335-b79b-9f05c6be737c',
      name: 'CS - 0x3 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-4\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'af41bef9-36a9-4f13-a0cb-9eb28f8f838c',
      name: 'CS - 0x3 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-4\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '27d627bb-b7bf-4bd9-bf79-83e232215ac7',
      name: 'CS - 1x0 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-5\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '95ad5c72-8c26-4959-9141-0ffec726f46c',
      name: 'CS - 1x0 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-5\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'c5887c6a-3297-4200-ae61-c6395516c87f',
      name: 'CS - 1x1 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-6\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '99e4331e-17ad-4827-bb96-cd8814ebae12',
      name: 'CS - 1x1 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-6\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'f2de9455-f1b5-4b97-8623-890f5e7d93b0',
      name: 'CS - 1x2 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-7\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '6d13a8db-13e9-40c0-94ef-69d2dbae20a3',
      name: 'CS - 1x2 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-7\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '73d2d790-96e2-4e36-a07b-8d4fc9960976',
      name: 'CS - 1x3 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-8\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '0ea0a3c5-7e28-4aa9-a19e-2240a0fbd1f6',
      name: 'CS - 1x3 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-8\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '21db576a-5020-4f16-b28e-d6d6d68334c1',
      name: 'CS - 2x0 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-9\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'cbe6f27f-da6d-4ea1-a2bc-10c10ce87a36',
      name: 'CS - 2x0 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-9\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '5fec1c22-d2a8-4d5f-8fd6-37f55abc944d',
      name: 'CS - 2x1 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-10\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '97e5bbb0-a394-44c6-86f8-34e8d27c6849',
      name: 'CS - 2x1 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-10\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'bd64e1d9-d648-472e-871a-ac4545c558a6',
      name: 'CS - 2x2 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-11\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '84c71697-ee61-4a61-85fe-10b5e1931bd5',
      name: 'CS - 2x2 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-11\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'ff6b3558-4475-440c-8a2d-6f1bbcca685d',
      name: 'CS - 2x3 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-12\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '49dd24f6-e24a-4638-95a1-dd0ea44fba52',
      name: 'CS - 2x3 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-12\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '9178fa0d-540e-43ec-b158-2171cdc84a38',
      name: 'CS - 3x0 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-13\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'd0559b97-0321-4137-b9c3-c1f85cba460d',
      name: 'CS - 3x0 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-13\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '62c45a0c-5a9d-45ce-9d52-e64743cd7345',
      name: 'CS - 3x1 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-14\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '02296783-35fb-4030-999a-744fa96e5624',
      name: 'CS - 3x1 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-14\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'bb4a59f8-c35f-4fd9-b37b-53fae926eef0',
      name: 'CS - 3x2 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-15\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '804da299-583f-494b-9248-107ca46881ad',
      name: 'CS - 3x2 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-15\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '7178126c-d15f-436c-ab0f-c5da064b1adb',
      name: 'CS - 3x3 FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-16\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '505610f3-cd49-4fbd-9247-9b4f17e918ed',
      name: 'CS - 3x3 FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-16\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'e298716c-9c4b-4d3f-8ee1-dae803432dcd',
      name: 'CS - Win Visitado FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-17\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '5cb12bb4-525a-46eb-80eb-76621f319074',
      name: 'CS - Win Visitado FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-17\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'e9f2ec92-45e1-40e7-824a-3b4bc5bde2ce',
      name: 'CS - Win Visitante FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-18\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'b0fee321-cb9c-40fb-8191-571f9b76baac',
      name: 'CS - Win Visitante FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-18\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: '12d6e19e-32f9-49ce-b909-dc0f8aaa81f3',
      name: 'CS - Outro Empate FT - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-19\'].back',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a7b1-4f6c-ac20-3f8efc233f1f',
      name: 'CS - Outro Empate FT - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'correct score-19\'].lay',
      dataType: 'market volume',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12asdas311',
      name: 'CS 0x0 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-1\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12dasd31222',
      name: 'CS 0x0 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-1\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122333',
      name: 'CS 1x1 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-2\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123444',
      name: 'CS 1x1 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-2\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312233555',
      name: 'CS 2x2 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-3\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231234666',
      name: 'CS 2x2 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-3\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122335777',
      name: 'CS 1x0 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-4\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312346888',
      name: 'CS 1x0 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-4\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231223357999',
      name: 'CS 2x0 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-5\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123468000',
      name: 'CS 2x0 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-5\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312233579222',
      name: 'CS 2x1 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-6\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312346803333',
      name: 'CS 2x1 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-6\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122335792312asd',
      name: 'CS 0x1 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-7\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123468034444',
      name: 'CS 0x1 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-7\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122335792345555',
      name: 'CS 0x2 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-8\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231234680345666',
      name: 'CS 0x2 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-8\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231223357923457777',
      name: 'CS 1x2 HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-9\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312346803456888',
      name: 'CS 1x2 HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-9\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231223357923457999',
      name: 'CS Outro HT back',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-10\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123468034568100',
      name: 'CS Outro HT lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'half time score-10\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a7b1-4f612312',
      name: 'Draw no Bet Casa - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'draw no bet-1\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a7b1-4f612312355',
      name: 'Draw no Bet Casa - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'draw no bet-1\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-612312',
      name: 'Draw no Bet Visitante - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'draw no bet-2\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a2312asd123s',
      name: 'Draw no Bet Visitante - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'draw no bet-2\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a2312aasdad123asd123fgasdsd123s',
      name: 'BTTS Sim - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-1\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a2312aasd12387asdjhk123897asdkhjgasdsd123s',
      name: 'BTTS Sim - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-1\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aedasdhkjadhkjh127d98789123s',
      name: 'BTTS Não - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-2\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'easkjak18923798asdlj1237asdklsdsd123s',
      name: 'BTTS Não - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'both teams to score?-2\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '4fasdasd12389risosakldjlkrisoss123kjhasd8761231',
      name: 'Chance dupla - Casa ou empate - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'double chance-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389risosakldjlkrisoss123kjhasd8761232',
      name: 'Chance dupla - Casa ou empate - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'double chance-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389risosakldjlkrisoss123kjhasd8761233',
      name: 'Chance dupla - Empate ou visitante - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'double chance-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389risosakldjlkrisoss123kjhasd8761234',
      name: 'Chance dupla - Empate ou visitante - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'double chance-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389risosakldjlkrisoss123kjhasd8761235',
      name: 'Chance dupla - Casa ou visitante - Back',
      type: 'integer',
      jsonMap: 'marketOdds[\'double chance-3\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389risosakldjlkrisoss123kjhasd8761236',
      name: 'Chance dupla - Casa ou visitante - Lay',
      type: 'integer',
      jsonMap: 'marketOdds[\'double chance-3\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }];
    this.arnoldInputsHome = [{
      id: 'e692ad2f-f26a-481a-a865-e4c847072d6a',
      name: 'Partidas jogadas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Jogados',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '51e4868b-577d-49ab-ae01-0b0795348410',
      name: 'Partidas jogadas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogadosHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7de613e0-02ce-46e3-ba09-37ce0df8bf91',
      name: 'Partidas jogadas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogadosAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '890f2db9-1b7a-4663-a9f8-aa68f2a3dc19',
      name: 'Partidas vencidas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Vencidos',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '898b74b0-a64a-4289-aed3-b6f1299b4996',
      name: 'Porcentagem partidas vencidas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.VencidosPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '770b6b92-f721-4c1b-9c84-d3cfe59bb055',
      name: 'Partidas vencidas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.VencidosHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '48f126df-c159-4a01-b9e2-c60ddd06592b',
      name: 'Porcentagem partidas vencidas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.VencidosHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '87dc89d2-1dae-4f18-927b-cd68d858bced',
      name: 'Partidas vencidas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.VencidosAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c3efa6c5-42a0-4dd9-9f28-922c916e7743',
      name: 'Porcentagem partidas vencidas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.VencidosAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f9e22c92-4eae-4c88-97b4-9ac1d0a7a2c4',
      name: 'Partidas perdidas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Perdidos',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd99d227f-118f-47e7-9d1e-3b268ddcf021',
      name: 'Porcentagem partidas perdidas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PerdidosPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'dc4d5da6-c083-4849-af20-b41f14159018',
      name: 'Partidas perdidas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PerdidosHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '92527985-f499-4748-8db4-b3699deb4428',
      name: 'Porcentagem partidas perdidas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PerdidosHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f7dacc94-d6c0-4030-9000-6c734f5da2d5',
      name: 'Partidas perdidas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PerdidosAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f8637a58-f9f2-4677-a08b-01d99e4cc66d',
      name: 'Porcentagem partidas perdidas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PerdidosAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ff6abfb1-980a-4e3c-981c-13cacb5b3580',
      name: 'Partidas empatadas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Empates',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cdda061b-bf82-450e-9299-a9dbfaf84956',
      name: 'Porcentagem partidas empatadas - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.EmpatesPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c43c3dc2-a276-4d39-8775-24c3bfae4a87',
      name: 'Partidas empatadas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.EmpatesHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '737c21a7-fbc8-4b45-a37c-a4c7768d7b38',
      name: 'Porcentagem partidas empatadas home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.EmpatesHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '61bc75ac-f64b-43f1-82d3-ce2ec05256c3',
      name: 'Partidas empatadas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.EmpatesAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '45d6e29e-d3f5-4bf4-8c77-25f17a99b815',
      name: 'Porcentagem partidas empatadas away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.EmpatesAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'fd7bda5a-12f4-41c8-81e4-049d761390ba',
      name: 'Rodada - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Rodada',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '100053fa-3a22-4153-9621-9ece3ce6ca5f',
      name: 'Pontuação Total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PontuacaoTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '12872760-5e68-4341-bc40-37a05ecfb5ca',
      name: 'Pontuação home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PontuacaoHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd3f99279-a648-4a7e-b304-731441d1a78d',
      name: 'Pontuação away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PontuaccaoAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '52751029-82af-44df-9d5f-5613d368182a',
      name: 'Diferença gol total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoalDiffTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c20d1218-a07b-420a-998c-8159ac76033e',
      name: 'Diferença gol home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoalDiffHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'bc8bdb11-626c-4afd-b79a-6e1772a61d2d',
      name: 'Diferença gol away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoalDiffAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '11d75dfe-84e9-47b8-8357-e21c3f334907',
      name: 'Gols marcados FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e5e161c9-decb-49d3-98eb-e82f10f9111c',
      name: 'Média gols marcados FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8a1310fd-d87c-472b-a1f7-10b6f65494f6',
      name: 'Gols marcados FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c5b461f9-fb35-4665-ab3d-7a099627c834',
      name: 'Média gols marcados FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosHomeMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '66d7a9b8-ccc1-44aa-9a4f-0033ec176d72',
      name: 'Gols marcados FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7581a620-8012-49ef-b1f7-31dba9a19d0f',
      name: 'Média gols marcados FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosAwayMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a2c274fa-38df-49ab-849b-42575755614e',
      name: 'Gols sofridos FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2f21a223-254e-4682-85fb-b0365b9e5343',
      name: 'Média gols sofridos FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b090f2d8-0c54-4162-bebd-39cd6ba63d8b',
      name: 'Gols sofridos FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd0f9ebd1-af0e-4b09-b5f2-123355cdffb8',
      name: 'Média gols sofridos FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosHomeMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '84b5ee4a-af08-498a-a1ec-6c50997dbb8d',
      name: 'Gols sofridos FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4ee7d0c4-cfda-4115-8840-a393454b41f1',
      name: 'Média gols sofridos FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosAwayMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd3d3a01e-8854-4ff5-a4b5-a69294cf5454',
      name: 'Total gols FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0dc4c2c3-fc69-4e07-834e-ffa759d46b64',
      name: 'Média total gols FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8517154b-4cd0-43ca-91a9-41b394a0dd1a',
      name: 'Total gols FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3aa32bb4-9957-4a77-b9fa-66499f38a4f4',
      name: 'Média total gols FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalHomeMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a09c4b39-1b31-4626-9ba7-45a38d947698',
      name: 'Total gols FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '688cfc11-c894-4094-8f3b-72f1c992c92b',
      name: 'Média total gols FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalAwayMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '66468ad9-4f1d-4494-acc2-b75587aee7dc',
      name: 'Gols marcados HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '597c6a3c-4ed2-43c4-9ed6-8390594fc2a6',
      name: 'Média gols marcados HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5c7c3b6c-bb91-4da2-ab46-f39ff13f1b21',
      name: 'Gols marcados HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'acb8817b-7a13-4128-9cc1-5f15296a2b46',
      name: 'Média gols marcados HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosHomeMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'aa3956d4-a203-43c2-b361-a4c8d4b9079c',
      name: 'Gols marcados HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7ac18fdb-186c-4ae7-99bd-57878b8d4e12',
      name: 'Média gols marcados HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosAwayMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '319ce450-fd5b-4107-9a62-d33325f66349',
      name: 'Gols sofridos HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2c1c4e27-c5f7-4e8e-bf2a-d289bb54e0f0',
      name: 'Média gols sofridos HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5298eef4-86dc-4271-a41c-7808b20b6d1b',
      name: 'Gols sofridos HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '018e8862-3b86-408c-bf06-1780572a61cd',
      name: 'Média gols sofridos HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosHomeMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'dbba6e11-bae3-4d76-8503-4e0ea96d6aeb',
      name: 'Gols sofridos HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '474fa1b6-2534-4c18-be44-e6770b4b9016',
      name: 'Média gols sofridos HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosAwayMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ee85f520-460a-4fc2-bdcf-8de6717f7c15',
      name: 'Total gols HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7c26a91e-dbc7-4bb2-9ae1-6f0c26f8b80d',
      name: 'Média total gols HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'fe9bf59e-2a5c-478f-954f-7aea9cab36a9',
      name: 'Total gols HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '69f46fc2-0065-4326-8575-29bc39b7c4c1',
      name: 'Média total gols HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalHomeMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd4a3c183-751c-4766-9043-eb7036d16bc6',
      name: 'Total gols HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c5f2b9f0-09c6-4c7b-ac14-873e404b3606',
      name: 'Média total gols HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsTotalAwayMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'fda5ef85-9d99-4e25-bde3-7b4479b30968',
      name: 'Gols marcados de cabeça - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosDeCabeca',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7f325114-5ad0-41c8-94f6-1fcd2f50cc6d',
      name: 'Média gols marcados de cabeça - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosDeCabecaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5525303d-6881-4b2e-ba15-1a3409bd070e',
      name: 'Gols marcados até 15 minutos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosAte15',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '88eaac37-c44a-4e27-986e-a9eeded6e5a8',
      name: 'Média gols marcados até 15 minutos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcadosAte15Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f031e7b1-2e25-4d8a-91fc-47d946d28bd7',
      name: 'Gols sofridos até 15 minutos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosAte15',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1aa75afd-c5eb-42fe-92e7-6700c39d3dfd',
      name: 'Média gols sofridos até 15 minutos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridosAte15Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '267fa109-0807-45ba-8937-2fe07d04516b',
      name: 'Gols marcados minuto 16 ao 30 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados16a30',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e171e301-e80c-4c41-8f33-2f7ef1f11990',
      name: 'Média gols marcados minuto 16 ao 30 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados16a30Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '57a2dc25-4d52-4e83-a333-b56b095592d6',
      name: 'Gols sofridos minuto 16 ao 30 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos16a30',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '9c79581a-1ef1-4349-9db6-46d44af85e06',
      name: 'Média gols sofridos minuto 16 ao 30 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos16a30Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '17ba3aa9-10a7-46c3-a546-6eba109d346a',
      name: 'Gols marcados minuto 31 ao 45 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados31a45',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5baae2c1-84fb-4b18-9c39-c160128eb680',
      name: 'Média gols marcados minuto 31 ao 45 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados31a45Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1dcd7c22-cb23-48b2-aaa7-234f34ec5edb',
      name: 'Gols sofridos minuto 31 ao 45 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos31a45',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '14fe3bfe-0cd0-4ec3-b81b-b632bced03ef',
      name: 'Média gols sofridos minuto 31 ao 45 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos31a45Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5df75106-d5e1-41e7-b83a-60e5c9b85c61',
      name: 'Gols marcados minuto 46 ao 60 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados46a60',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c96fba28-8f3f-4b8a-9863-f4e281bee9ea',
      name: 'Média gols marcados minuto 46 ao 60 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados46a60Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '09c8f710-0445-49cc-8587-bab35c61ea7d',
      name: 'Gols sofridos minuto 46 ao 60 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos46a60',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '07659313-d83f-43fe-a4f6-42c3ca2cff64',
      name: 'Média gols sofridos minuto 46 ao 60 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos46a60Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '90da5233-34e9-4ffd-a19b-95516be46a20',
      name: 'Gols marcados minuto 61 ao 75 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados61a75',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '77a1cf82-68e7-41b9-a89d-838370b539e1',
      name: 'Média gols marcados minuto 61 ao 75 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados61a75Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8b33d05e-0d3e-498c-97d1-5ac1b8726556',
      name: 'Gols sofridos minuto 61 ao 75 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos61a75',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '72b11861-636a-4f25-9c1b-17a42baac9fb',
      name: 'Média gols sofridos minuto 61 ao 75 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos61a75Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c196c6f0-e2b9-4afb-8f21-18fd08dc1f6c',
      name: 'Gols marcados minuto 76 ao 90 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados76a90',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'eac840aa-366a-40ef-aa56-8847714f70f4',
      name: 'Média gols marcados minuto 76 ao 90 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsMarcados76a90Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6ce09c98-3b35-4a14-bf2c-f5502e8b4f8a',
      name: 'Gols sofridos minuto 76 ao 90 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos76a90',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '345640c9-8320-4d26-a3c8-51b98d91b4e0',
      name: 'Média gols sofridos minuto 76 ao 90 - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GolsSofridos76a90Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2c30afcf-f188-4f1b-8349-f60b2f4dd885',
      name: 'Média chutes salvos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesSalvosMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1a8406bf-6f92-4312-a4ce-96d8da43283b',
      name: 'Chutes - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Chutes',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6b060f12-74d6-4d9c-946b-41ece92f5e27',
      name: 'Média chutes home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesHomeMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'bf48fe62-59b2-44ef-9fc4-888a21b210f1',
      name: 'Média chutes away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesAwayMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '039f6dda-ea07-4498-a581-66e579d0e2de',
      name: 'Chutes bloqueados - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesBloqueados',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5bf5a4a0-a33f-4d72-a6c9-1e4f0d2e4eb0',
      name: 'Média chutes bloqueados - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesBloqueadosMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1a2c5e7c-1e2e-4beb-96ba-b5c413861ce3',
      name: 'Chutes fora do gol - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesForaDoGol',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b0e83951-4c3d-4684-81a8-92f984e4d0c8',
      name: 'Média chutes fora do gol - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesForaDoGolMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '82c9b19c-539e-4b28-b151-b8073cf36644',
      name: 'Média chutes fora do gol home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesForaDoGolHomeMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7d3b8a91-2ccf-4655-8bac-32ce5070a2ce',
      name: 'Média chutes fora do gol away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesForaDoGolAwayMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8e7c6ab7-284a-40b4-bc4c-39ddc6def0b7',
      name: 'Chutes no gol - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesNoGol',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'de45ff3b-e8f4-4528-8f90-4a5eba4b5bf4',
      name: 'Média chutes no gol - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesNoGolMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd8522807-f25c-4784-8293-4059d10d02ce',
      name: 'Média chutes no gol home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesNoGolHomeMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '82531fcd-e441-492a-972d-979de9f308ca',
      name: 'Média chutes no gol away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesNoGolAwayMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f52059f9-accc-4c51-8971-a80d57a23cf1',
      name: 'Média chutes perigosos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesPerigososMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f45061da-7c76-498c-8e6a-37e85fdb7ed8',
      name: 'Média chutes no gol perigosos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesNoGolPerigososMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'acd2ff23-e44d-41e3-a713-572fc2cdb964',
      name: 'Média chutes fora do gol perigosos - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesForaDoGolPerigososMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '221f4db7-c0bc-45de-8619-5ae087921712',
      name: 'Média chutes dentro da area - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'abd8345f-7a71-4893-b927-5d2a2f5dbbd6',
      name: 'Média chutes no gol dentro da area - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ChutesNoGolDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '408590fb-1c42-4bcb-b0a4-7a04372856c8',
      name: 'Média posse de bola - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.PosseMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e162d8fc-0de4-4d7c-9865-ece4c097ceda',
      name: 'Escanteios - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.Escanteios',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e5dfcdbd-90a4-43cd-a082-e5971c8f096a',
      name: 'Média escanteios - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.EscanteiosMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2afd5184-949b-4f62-89f3-1f0824aaa255',
      name: 'Média cartão amarelo - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.CartaoAmareloMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a8dd9dd0-04d8-49a4-b6ba-11dfe2c99cf1',
      name: 'Média cartão vermelho - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.CartaoVermelhoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cc68beac-5739-43f2-9eff-b45a1029afb3',
      name: 'Média zona de perigo - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.ZonaDePerigoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7495b713-5277-42bb-9784-5ed2763c33fc',
      name: 'Média atacando dentro da área - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '05ac7739-5576-40f9-9685-8dbef2375e53',
      name: 'Média atacando diagonal direita - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoDiagonalDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4dff896a-bcdb-4497-956a-87efed1379f0',
      name: 'Média atacando diagonal esquerda - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoDiagonalEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c92db217-24bb-4db3-9b68-f6176523c336',
      name: 'Média atacando frente da área - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoFrenteDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '357c664c-62aa-49f4-b41a-88dc3f699d45',
      name: 'Média atacando fundo lado direito - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoFundoLadoDireitoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '72143adf-e1d0-4bc4-8f74-8f8802d046f9',
      name: 'Média atacando fundo lado esquerdo - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoFundoLadoEsquerdoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c9af09a7-3421-43c5-8a04-62e7bee0cce5',
      name: 'Média atacando intermediária - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoIntermediariaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c89441e0-b992-41d8-b748-ed905c168b56',
      name: 'Média atacando lateral direita - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoLateralDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'de1d21e4-f0b2-4497-a0e3-693104bb4a24',
      name: 'Média atacando lateral esquerda - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.AtacandoLateralEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'dc18b4d1-053b-4b94-866f-969d31871bbe',
      name: 'Média defendendo dentro da área - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b3ea74aa-00a3-4707-81d7-1abf75cf0e7b',
      name: 'Média defendendo diagonal direita - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoDiagonalDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '527fa5f8-642a-40f8-8f9c-d267b8ed87cc',
      name: 'Média defendendo diagonal esquerda - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoDiagonalEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '06c612dc-918b-4d0e-8cb1-7ae247be5e6b',
      name: 'Média defendendo frente da área - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoFrenteDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1f1825b5-bc28-4463-bc6d-e93f8d48a37b',
      name: 'Média defendendo fundo lado esquerdo - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoFundoLadoDireitoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0ba14329-f776-4056-91c5-93718bde7628',
      name: 'Média defendendo lado esquerdo - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoFundoLadoEsquerdoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e646fe83-12d2-4be3-96b2-d4334f5a52e2',
      name: 'Média defendendo intermediária - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoIntermediariaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '02ce942c-c667-4712-ad76-6c6daa658878',
      name: 'Média defendendo lateral direita - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoLateralDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'be1f4011-e5f5-4bb2-bee2-3729f9093326',
      name: 'Média defendendo lateral esquerda - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.DefendendoLateralEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd4efd55a-c8ef-417f-90e9-f2f11890edea',
      name: 'Média meio campo central - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MeioCampoCentralMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '26281ac6-0a83-4f2e-81ba-b2c4ea4537f4',
      name: 'Média meio campo direita - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MeioCampoDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7f11d81a-bc04-443d-b2ae-1ff9405a9ccf',
      name: 'Média meio campo esquerda - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MeioCampoEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0606e1c3-01a6-49e5-9051-f65c13279106',
      name: 'Total jogos over 0,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b916375e-4ebb-4f3d-99ed-f43b9277ed29',
      name: 'Porcentagem jogos over 0,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '12cf5063-6363-4070-a7e3-a4d1ad12b346',
      name: 'Total jogos over 1,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e5725ea4-bca1-4d96-ac44-22bc186b8cb1',
      name: 'Porcentagem jogos over 1,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6134eb6c-1ac5-42b5-abee-0ad2f9a50c1e',
      name: 'Total jogos over 2,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1610964b-20d1-43cb-8824-41b459de0cb6',
      name: 'Porcentagem jogos over 2,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a7257ab0-4499-43d4-8d8d-8c161e20b018',
      name: 'Total jogos over 3,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd6ba4c1e-0332-4f38-8440-03b49b83e828',
      name: 'Porcentagem jogos over 3,5 FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '9543b301-445a-490f-8790-bff4c945a52c',
      name: 'Total jogos over 0,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f519b226-3dc4-45b1-9058-ff7851b249f6',
      name: 'Porcentagem jogos over 0,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7a577745-2aa1-426c-b93a-e9e8579a926e',
      name: 'Total jogos over 1,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f023aa96-d945-4414-abaf-994b35b0016d',
      name: 'Porcentagem jogos over 1,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '925632e2-e7a3-43c7-abfd-db6a2c42933c',
      name: 'Total jogos over 2,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '96fea658-c77c-454b-920e-cdc3667335ad',
      name: 'Porcentagem jogos over 2,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '319397ef-ef9f-4be7-b2cf-96de64e3152c',
      name: 'Total jogos over 3,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd527f051-28b4-48e2-8852-1661cb8b2872',
      name: 'Porcentagem jogos over 3,5 HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4bea3234-d493-48ab-84a9-fff0ec07982e',
      name: 'Total jogos BTTS sim FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'dcf52294-2485-41d5-b3a4-37027a4196e0',
      name: 'Porcentagem jogos BTTS sim FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSPorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4d33a971-eb16-4915-a0f5-3c44213fffa7',
      name: 'Total jogos BTTS sim HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '348532e8-b905-4e58-8b38-fbcf6f57919c',
      name: 'Porcentagem jogos BTTS sim HT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSPorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b6503cfc-2558-45d8-a2e3-04017f74d681',
      name: 'Total goleada FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoleadaTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cc258fec-c87e-42b3-89e6-8dd7d907a993',
      name: 'Porcentagem goleada FT - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoleadaPorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ac316832-12fa-4927-ae68-260ff9dcacd4',
      name: 'Jogos over 0,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1632de3a-df4a-4ad1-bcad-38f7cb1fda7d',
      name: 'Porcentagem jogos over 0,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'bb352842-8edd-4a49-8fcf-32bda1e87caa',
      name: 'Jogos over 1,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '19560f03-e5e5-40bc-92b3-38cf2fad2c3e',
      name: 'Porcentagem jogos over 1,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e08d9fb5-de4f-43eb-874a-e487ab834f71',
      name: 'Jogos over 2,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e6d2e70d-67ea-45a6-a9b5-db1f17eb9d74',
      name: 'Porcentagem jogos over 2,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'af77421e-0883-4a7a-8886-40cbcbedaa5f',
      name: 'Jogos over 3,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '71c5f174-49bd-4bd8-b5cf-771716756c40',
      name: 'Porcentagem jogos over 3,5 FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '12191b36-9c1a-4dcf-a226-77667259a6e9',
      name: 'Jogos over 0,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3d4d13e3-2fe0-436f-89be-59693287011c',
      name: 'Porcentagem jogos over 0,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7d4684c8-5be2-4833-a13b-2cb26c66de5d',
      name: 'Jogos over 1,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5b71157f-a25c-4963-a49a-6e291c30f0e8',
      name: 'Porcentagem jogos over 1,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '752e5315-b0b0-4e9c-ae22-0a17c82703cd',
      name: 'Jogos over 2,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f12073ae-fb03-43d7-bd73-a34a7c96ce7a',
      name: 'Porcentagem jogos over 2,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '34fc1058-5538-4553-91f6-9f6d728724ed',
      name: 'Jogos over 3,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ef532cf1-ad59-41fc-b188-7adb72391b58',
      name: 'Porcentagem jogos over 3,5 HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e27d2152-07ad-4462-b74b-a93a01b313c0',
      name: 'Jogos BTTS sim FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd02811cf-d134-4bd0-ad92-d34d0c3c11ef',
      name: 'Porcentagem jogos BTTS sim FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSPorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6fbde3de-889b-4f5f-a78d-b98c755d9d3a',
      name: 'Jogos BTTS sim HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f9893146-ccee-4b3f-b0f4-4f33637345a2',
      name: 'Porcentagem Jogos BTTS sim HT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSPorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a5f86305-7722-4a06-aded-7fb8dc0dcb1c',
      name: 'Goleada FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoleadaHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7570902e-d79a-442a-a127-9774f8e9a151',
      name: 'Porcentagem goleada FT home - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoleadaPorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '94297cb1-9a5d-4fd9-b21c-b2a9f36298f7',
      name: 'Jogos over 0,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'eca42aeb-4ae5-46a8-8672-37ce93389ba4',
      name: 'Porcentagem jogos over 0,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c157cbda-22ba-4e34-af07-ba1740421c81',
      name: 'Jogos over 1,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '137939a3-a7ec-447a-bd61-8273b4c5f84a',
      name: 'Porcentagem jogos over 1,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '19810db2-9f73-44fc-b4f5-73f062731b46',
      name: 'Jogos over 2,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'dadc9ce3-2dcd-40df-96c5-0ffc3cb529ca',
      name: 'Porcentagem jogos over 2,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '28f0e425-229d-4d76-96a1-dd8b6bc529bb',
      name: 'Jogos over 3,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '28a5ce6f-4988-4ec8-9ea7-bf41c75ae61c',
      name: 'Porcentagem jogos over 3,5 FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e00c3ca2-f8b8-49f7-8911-447b470bee21',
      name: 'Jogos over 0,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '87332b8c-f501-4a75-9280-1ef26c3021d7',
      name: 'Porcentagem jogos over 0,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver05PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f011bdbe-a79c-4a02-a972-9a0ac09d92d8',
      name: 'Jogos over 1,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3d7814e4-596e-4bb0-9ca7-e2b2e06ecac1',
      name: 'Porcentagem jogos over 1,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver15PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '716efc78-4f92-485f-9595-4c22c88df5f5',
      name: 'Jogos over 2,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '240da14a-1e1f-4eed-9cd8-c52bdf4d62d9',
      name: 'Porcentagem jogos over 2,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver25PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '61e9d324-fe95-490c-b293-e806baf20879',
      name: 'Jogos over 3,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '472eee32-75cb-430a-a215-86677ea430e3',
      name: 'Porcentagem jogos over 3,5 HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosOver35PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '108a1c60-026b-452c-86e1-6925705da17c',
      name: 'Jogos BTTS sim FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '466ffd3c-7714-4773-850e-58c4fc629cb9',
      name: 'Porcentagem jogos BTTS sim FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSPorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '47f8a03e-e1c3-4ad3-9370-416189f47c25',
      name: 'Jogos BTTS sim HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5f83317e-ac85-458f-9aae-2adbca084bff',
      name: 'Porcentagem jogos BTTS sim HT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.JogosBTTSPorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '20948153-dfaa-4ee7-bb28-012f7bac3b07',
      name: 'Goleada FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoleadaAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b',
      name: 'Porcentagem goleada FT away - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.GoleadaPorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b1660',
      name: 'Marcou primeiro gol total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b7871',
      name: 'Porcentagem marcou primeiro gol total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b4172',
      name: 'Marcou primeiro gol venceu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolVenceuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b8373',
      name: 'Porcentagem marcou primeiro gol venceu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolVenceuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b9134',
      name: 'Marcou primeiro gol perdeu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolPerdeuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b9665',
      name: 'Porcentagem marcou primeiro gol perdeu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolPerdeuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b1606',
      name: 'Marcou primeiro gol empatou total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolEmpatouTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b4597',
      name: 'Porcentagem marcou primeiro gol empatou total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolEmpatouTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b2788',
      name: 'Marcou primeiro gol jogando casa - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b7759',
      name: 'Porcentagem marcou primeiro gol jogando casa - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b66710',
      name: 'Marcou primeiro gol jogando casa venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolVenceuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b5511',
      name: 'Porcentagem marcou primeiro gol jogando casa venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolVenceuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b73712',
      name: 'Marcou primeiro gol jogando casa perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolPerdeuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b33113',
      name: 'Porcentagem marcou primeiro gol jogando casa perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolPerdeuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b9814',
      name: 'Marcou primeiro gol jogando casa empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolEmpatouHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b91115',
      name: 'Porcentagem marcou primeiro gol jogando casa empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolEmpatouHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b55316',
      name: 'Marcou primeiro gol jogando fora - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b22817',
      name: 'Porcentagem marcou primeiro gol jogando fora - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b98618',
      name: 'Marcou primeiro gol jogando fora venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolVenceuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b77219',
      name: 'Porcentagem marcou primeiro gol jogando fora venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolVenceuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b37220',
      name: 'Marcou primeiro gol jogando fora perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolPerdeuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b10021',
      name: 'Porcentagem marcou primeiro gol jogando fora perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolPerdeuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b99622',
      name: 'Marcou primeiro gol jogando fora empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolEmpatouAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b65823',
      name: 'Porcentagem marcou primeiro gol jogando fora empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.MarcouPrimeiroGolEmpatouAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b50524',
      name: 'Sofreu primeiro gol total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b48825',
      name: 'Porcentagem sofreu primeiro gol total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b55926',
      name: 'Sofreu primeiro gol venceu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolVenceuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b70927',
      name: 'Porcentagem sofreu primeiro gol venceu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolVenceuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b85828',
      name: 'Sofreu primeiro gol perdeu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolPerdeuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b25729',
      name: 'Porcentagem sofreu primeiro gol perdeu total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolPerdeuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b32330',
      name: 'Sofreu primeiro gol empatou total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolEmpatouTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b53331',
      name: 'Porcentagem sofreu primeiro gol empatou total - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolEmpatouTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b92932',
      name: 'Sofreu primeiro gol jogando casa - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b10833',
      name: 'Porcentagem sofreu primeiro gol jogando casa - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b10234',
      name: 'Sofreu primeiro gol jogando casa venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolVenceuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b6735',
      name: 'Porcentagem sofreu primeiro gol jogando casa venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolVenceuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b70936',
      name: 'Sofreu primeiro gol jogando casa perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolPerdeuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b55437',
      name: 'Porcentagem sofreu primeiro gol jogando casa perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolPerdeuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b99338',
      name: 'Sofreu primeiro gol jogando casa empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolEmpatouHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b83339',
      name: 'Porcentagem sofreu primeiro gol jogando casa empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolEmpatouHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b73440',
      name: 'Sofreu primeiro gol jogando fora - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b1213512356041',
      name: 'Porcentagem sofreu primeiro gol jogando fora - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b942',
      name: 'Sofreu primeiro gol jogando fora venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolVenceuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b42643',
      name: 'Porcentagem sofreu primeiro gol jogando fora venceu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolVenceuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b58644',
      name: 'Sofreu primeiro gol jogando fora perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolPerdeuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b46545',
      name: 'Porcentagem sofreu primeiro gol jogando fora perdeu - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolPerdeuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b98046',
      name: 'Sofreu primeiro gol jogando fora empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolEmpatouAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b82247',
      name: 'Porcentagem sofreu primeiro gol jogando fora empatou - CASA',
      type: 'integer',
      jsonMap: 'preLiveHome.SofreuPrimeiroGolEmpatouAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }];
    this.arnoldInputsAway = [{
      id: '937d6403-1927-4600-866a-547981b60b61',
      name: 'Partidas jogadas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Jogados',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '69871418-df33-4d8a-a185-a9606a016937',
      name: 'Partidas jogadas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogadosHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5e28a3da-bb13-4227-a55e-577852543e8a',
      name: 'Partidas jogadas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogadosAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5d451f84-c870-422a-897b-1ee394d0699a',
      name: 'Partidas vencidas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Vencidos',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0ccfeb32-ee2a-442b-9bd0-319b89860e78',
      name: 'Porcentagem partidas vencidas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.VencidosPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2a937ce2-5429-4dbc-86e8-4150ca82c745',
      name: 'Partidas vencidas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.VencidosHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '737d9083-ae7a-4717-a3c7-57f1c49dd09f',
      name: 'Porcentagem partidas vencidas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.VencidosHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '77fa3e8c-4ec8-4e0a-99f7-f2e7589efd05',
      name: 'Partidas vencidas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.VencidosAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7cc15184-3665-41b0-9968-0aa55abe5eb8',
      name: 'Porcentagem partidas vencidas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.VencidosAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '96d35a8d-0da1-4dbf-a238-b6710631a438',
      name: 'Partidas perdidas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Perdidos',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1b64e7b0-bd27-462e-85ca-3942d40e8efe',
      name: 'Porcentagem partidas perdidas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PerdidosPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '01e12495-032e-4b94-b6aa-d1fdc8ac6c69',
      name: 'Partidas perdidas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PerdidosHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e154abe5-90c1-4b7b-a92a-6a95130caed5',
      name: 'Porcentagem partidas perdidas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PerdidosHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '48c09ad2-6bd5-47d7-8d1d-19416c8a283e',
      name: 'Partidas perdidas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PerdidosAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c28970ad-5d94-4303-a2f6-872e2db69254',
      name: 'Porcentagem partidas perdidas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PerdidosAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd565ee73-182b-4506-a7ad-1d9d803fa31f',
      name: 'Partidas empatadas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Empates',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1b42190f-926a-49d2-a8c1-a614ced8c04e',
      name: 'Porcentagem partidas empatadas - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.EmpatesPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ac4b117a-afc0-40fa-b5f2-264d2940dad6',
      name: 'Partidas empatadas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.EmpatesHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e3eae67d-907f-404a-9cdc-fb115aef0985',
      name: 'Porcentagem partidas empatadas home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.EmpatesHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8fb353fb-f526-427d-b4c5-03b94c60c303',
      name: 'Partidas empatadas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.EmpatesAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3c99c8ae-3d09-463c-8a9d-8aaf9bb2c226',
      name: 'Porcentagem partidas empatadas away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.EmpatesAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '99c0ed74-d225-48cf-a7f7-c49649e4b145',
      name: 'Rodada - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Rodada',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ac4240e0-7cf2-4dd2-bd6c-67873c4ab342',
      name: 'Pontuação Total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PontuacaoTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '06cd8c58-9cf4-4a7d-8b2f-8429d835ade3',
      name: 'Pontuação home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PontuacaoHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4e8de28a-08ff-4818-8b17-be37f4697d9a',
      name: 'Pontuação away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PontuaccaoAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7b2a6fd5-616e-41f5-93a2-6049210e2b02',
      name: 'Diferença gol total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoalDiffTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '43091dbd-779f-4131-8a61-fd7ceaa52a2b',
      name: 'Diferença gol home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoalDiffHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'af495827-7f55-4b38-805e-24af2c3a9ea8',
      name: 'Diferença gol away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoalDiffAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1176b7af-55cd-4055-877c-78bbac61963e',
      name: 'Gols marcados FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5f9f4cd3-60d0-4008-bd25-82be501cb594',
      name: 'Média gols marcados FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd1166dd7-13eb-4d10-bff9-f9d401640179',
      name: 'Gols marcados FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8c7130ad-563f-4409-9ccc-c3e71121ba24',
      name: 'Média gols marcados FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosHomeMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '130f3d55-be9c-4f94-92ab-3240846b9cae',
      name: 'Gols marcados FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd142d3db-0cf7-4441-8a12-7b9f46a21ca6',
      name: 'Média gols marcados FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosAwayMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '199ff2b8-bee8-4f2e-bbe0-6deb9e278783',
      name: 'Gols sofridos FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '58187a44-4914-4022-9c29-6d4fbdff46a1',
      name: 'Média gols sofridos FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7a139bcf-4f2c-4e5d-a974-f04195ea5c50',
      name: 'Gols sofridos FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '53a41bc2-8fa0-4c81-a9f1-e286aec0a6dc',
      name: 'Média gols sofridos FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosHomeMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c83675ba-c118-4377-8f73-dedbc28773a0',
      name: 'Gols sofridos FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a0c1c237-dce8-4316-ae19-c037b47b7716',
      name: 'Média gols sofridos FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosAwayMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0dbdddd6-225b-44bf-9fe2-d85d2c410b25',
      name: 'Total gols FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '074f322d-1afb-4275-a64b-822dc3420df1',
      name: 'Média total gols FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'acfdd6d7-3ee8-4ab4-9dd4-e6df974852f5',
      name: 'Total gols FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'dbbe649b-d0fd-4581-ac3a-5768da11f94d',
      name: 'Média total gols FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalHomeMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0f116596-c536-4fa5-9785-69c3744989a0',
      name: 'Total gols FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '41d9b9ac-1445-436e-b6f6-6e5c9a303b62',
      name: 'Média total gols FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalAwayMediaFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'eaa98ee3-a76d-47aa-97c7-a90066fa05ed',
      name: 'Gols marcados HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6a3a7758-75b6-47aa-aa22-e6a528bdc447',
      name: 'Média gols marcados HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'fddf855c-c008-4e91-aa20-febd47159149',
      name: 'Gols marcados HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ca72b99b-459f-4f4b-a939-fcb45ca97bc7',
      name: 'Média gols marcados HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosHomeMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '088378d3-0fb9-4697-84e3-0d4031cee1b7',
      name: 'Gols marcados HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3494d6dd-b203-4f50-9748-ac3f3588e1f2',
      name: 'Média gols marcados HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosAwayMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4ca7d3a8-0f28-436a-b2c5-e53e86ce0bfd',
      name: 'Gols sofridos HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2c87a864-558d-45ef-8142-174cea9c93bd',
      name: 'Média gols sofridos HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b414dbea-9204-476c-95ee-ce2bcfc2b86c',
      name: 'Gols sofridos HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0b1930e3-b73d-4594-8cac-3c6d1d249087',
      name: 'Média gols sofridos HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosHomeMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f22e66a4-3ff8-4184-b67c-d3e2c53cbad5',
      name: 'Gols sofridos HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b20a8d20-22f3-4c51-968d-d330c54dd1ef',
      name: 'Média gols sofridos HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosAwayMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd836efe0-eee1-447b-b15a-0f64dfbd234d',
      name: 'Total gols HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3f632bc7-8780-42ec-8c55-8c633c4bfe5e',
      name: 'Média total gols HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'be007ca8-c609-4a3d-83a9-1645f7382161',
      name: 'Total gols HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a18da1c5-1168-4611-bcdd-c5e96bdf0b9a',
      name: 'Média total gols HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalHomeMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2cca5262-2639-41c9-b91a-37a659e98bba',
      name: 'Total gols HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'aa2bb9e8-816b-4ada-81a9-eb252ce1e293',
      name: 'Média total gols HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsTotalAwayMediaHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3822fe4d-7758-4325-b31e-5c6af7ae7b1c',
      name: 'Gols marcados de cabeça - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosDeCabeca',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '599f59d5-8df1-4157-903b-83f9b46e8876',
      name: 'Média gols marcados de cabeça - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosDeCabecaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7156f797-dfd9-49d2-91a4-03bad43d6d25',
      name: 'Gols marcados até 15 minutos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosAte15',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '96cad111-9b3a-4ea8-ac45-c57a6f0d5e6a',
      name: 'Média gols marcados até 15 minutos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcadosAte15Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '02da1b70-1c7f-4fff-ad3e-c7a7595dca08',
      name: 'Gols sofridos até 15 minutos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosAte15',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '14a8a4f1-8aca-404c-8090-9ef65e207ed7',
      name: 'Média gols sofridos até 15 minutos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridosAte15Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'eafefabe-1fd8-4ff9-94bd-a7c9e108b70e',
      name: 'Gols marcados minuto 16 ao 30 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados16a30',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '717078eb-4dd3-4836-b382-c65fbb905078',
      name: 'Média gols marcados minuto 16 ao 30 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados16a30Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'bd43b0df-02dd-4bc1-b93e-8a43a9132aee',
      name: 'Gols sofridos minuto 16 ao 30 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos16a30',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6afaccb0-6ca8-4c05-aa5a-c0f30eeccd6c',
      name: 'Média gols sofridos minuto 16 ao 30 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos16a30Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '75fa8a46-d079-482e-94f7-7bbc15c70b64',
      name: 'Gols marcados minuto 31 ao 45 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados31a45',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b2f58104-74da-4a8f-ab36-950d23ffc607',
      name: 'Média gols marcados minuto 31 ao 45 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados31a45Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '66bf2226-2286-4624-835c-3dec20014d16',
      name: 'Gols sofridos minuto 31 ao 45 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos31a45',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2f4b9e0a-0ffb-499b-835c-ad394feae08b',
      name: 'Média gols sofridos minuto 31 ao 45 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos31a45Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ea768e8c-5c59-473c-80ef-f2751cdca695',
      name: 'Gols marcados minuto 46 ao 60 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados46a60',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6b9a31db-71a5-4565-bab6-128a588f5998',
      name: 'Média gols marcados minuto 46 ao 60 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados46a60Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ca8f1ec0-0346-43a3-9da9-093c1bf463da',
      name: 'Gols sofridos minuto 46 ao 60 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos46a60',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '9f8ead03-7f3d-4e02-b543-06329e6aa586',
      name: 'Média gols sofridos minuto 46 ao 60 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos46a60Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c28fb584-d0d8-4907-9aff-34e04755c95c',
      name: 'Gols marcados minuto 61 ao 75 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados61a75',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2581ce69-02a5-4eff-afe3-ab847ac54975',
      name: 'Média gols marcados minuto 61 ao 75 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados61a75Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '51ee3ce1-99ab-470f-8ab6-91de732501c5',
      name: 'Gols sofridos minuto 61 ao 75 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos61a75',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '777bb9f5-79f7-47f5-af7a-3e81f18ad3d0',
      name: 'Média gols sofridos minuto 61 ao 75 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos61a75Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '31dcaecf-c268-4c0b-a4c0-398c17d8ce27',
      name: 'Gols marcados minuto 76 ao 90 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados76a90',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8095d876-a0ed-480e-b0e4-7dd3e25ced5d',
      name: 'Média gols marcados minuto 76 ao 90 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsMarcados76a90Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b27a5fea-e6ec-415e-bfe2-cf6859bc3b09',
      name: 'Gols sofridos minuto 76 ao 90 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos76a90',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd039d3aa-5290-4a16-ba53-0cc57cb9d2e4',
      name: 'Média gols sofridos minuto 76 ao 90 - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GolsSofridos76a90Media',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '23cbcc17-0084-4082-b4fe-a2100ddc87b8',
      name: 'Média chutes salvos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesSalvosMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '56a54e0d-b091-4179-9ad1-0997d5eb2503',
      name: 'Chutes - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Chutes',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '29d72aa2-b72c-4de7-850c-8ee4dcd53022',
      name: 'Média chutes home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesHomeMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1108c35e-4ddc-4811-b744-b96e19e27368',
      name: 'Média chutes away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesAwayMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '134a1766-cb10-4172-b95a-3391787c5b3c',
      name: 'Chutes bloqueados - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesBloqueados',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '9bd5e08e-bb3f-4983-a4e2-df6f7c58a89b',
      name: 'Média chutes bloqueados - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesBloqueadosMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6d45a871-afad-4227-a0da-c3fb1142278a',
      name: 'Chutes fora do gol - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesForaDoGol',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd321eb08-79d2-4c7c-a2f3-eac627e86ff8',
      name: 'Média chutes fora do gol - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesForaDoGolMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '66c5cd2a-efd4-493d-a0a8-075048f33391',
      name: 'Média chutes fora do gol home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesForaDoGolHomeMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c2b001e1-9a03-4dcf-9d3e-414e8d396f9b',
      name: 'Média chutes fora do gol away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesForaDoGolAwayMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a7c8b70c-4f58-447d-8b7d-b15518db122b',
      name: 'Chutes no gol - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesNoGol',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '37f27a31-5d24-4f50-9e5e-4e9e54c6d93e',
      name: 'Média chutes no gol - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesNoGolMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b54c87c5-45a0-4b26-8cb7-831198cc8c4f',
      name: 'Média chutes no gol home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesNoGolHomeMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '053c11a8-3998-42b6-aa3a-765b813869d8',
      name: 'Média chutes no gol away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesNoGolAwayMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f4414ff9-01af-403e-9361-49561d2e4cf2',
      name: 'Média chutes perigosos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesPerigososMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '08f297ca-99b5-485e-a75c-33474f81d0ce',
      name: 'Média chutes no gol perigosos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesNoGolPerigososMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a143e15c-d857-422f-9413-d997430c4f31',
      name: 'Média chutes fora do gol perigosos - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesForaDoGolPerigososMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'bbbe71f2-b699-4bce-9fd7-c3e8a8646de8',
      name: 'Média chutes dentro da area - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2f647811-9319-4486-beb3-40c73c942f15',
      name: 'Média chutes no gol dentro da area - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ChutesNoGolDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4ee0bada-1bd3-43be-b1ae-cfff2b849681',
      name: 'Média posse de bola - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.PosseMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '81955f8e-70c9-4785-af01-306acca65fc1',
      name: 'Escanteios - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.Escanteios',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3e0afabb-9b95-42e3-bf88-e5fd34148558',
      name: 'Média escanteios - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.EscanteiosMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cd09f81d-fbab-4a52-98c8-d8ab2ce1ba4d',
      name: 'Média cartão amarelo - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.CartaoAmareloMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '45356c82-da76-49b4-8c5a-19b184126f83',
      name: 'Média cartão vermelho - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.CartaoVermelhoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3c8bf125-b72d-4ff8-9caf-3e0e6825d902',
      name: 'Média zona de perigo - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.ZonaDePerigoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c0d9474a-d3eb-4abd-b712-a56c816c66cc',
      name: 'Média atacando dentro da área - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '14219ca7-4f34-4a47-8079-63ab0d6e5f4d',
      name: 'Média atacando diagonal direita - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoDiagonalDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7d8f4712-c6c7-414b-8612-73421dac6b82',
      name: 'Média atacando diagonal esquerda - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoDiagonalEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1ce0751e-04d9-441d-be3e-50bc799e268f',
      name: 'Média atacando frente da área - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoFrenteDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '95fd1d11-ac3c-44a1-9c0f-03e8e71ce8f3',
      name: 'Média atacando fundo lado direito - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoFundoLadoDireitoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b040c05b-1cb4-4412-bfe9-27fe052eadc8',
      name: 'Média atacando fundo lado esquerdo - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoFundoLadoEsquerdoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4266e03c-095b-4c56-ba01-e78e763c12d4',
      name: 'Média atacando intermediária - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoIntermediariaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ff5caf29-9555-4c6e-abb6-a47b32e1b297',
      name: 'Média atacando lateral direita - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoLateralDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7a236307-7a1c-4a64-894a-c445575c63f2',
      name: 'Média atacando lateral esquerda - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.AtacandoLateralEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '06c39df6-c9d8-45af-8cc9-f92874669eee',
      name: 'Média defendendo dentro da área - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoDentroDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '68c06f59-b10d-4075-827f-0f841858c027',
      name: 'Média defendendo diagonal direita - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoDiagonalDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a8fd5693-8b22-4f03-845c-9b52e0595cb6',
      name: 'Média defendendo diagonal esquerda - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoDiagonalEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8fedb1df-c46c-41a6-8c1a-1cfdd09097bd',
      name: 'Média defendendo frente da área - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoFrenteDaAreaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0b884105-3a25-44aa-bb8e-1d82b3d8f5fd',
      name: 'Média defendendo fundo lado esquerdo - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoFundoLadoDireitoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f8edb01c-d6d3-46f4-afd4-d9c4c93aeba3',
      name: 'Média defendendo lado esquerdo - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoFundoLadoEsquerdoMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '03436149-d50c-4ca9-ab28-1c9d9488740b',
      name: 'Média defendendo intermediária - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoIntermediariaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cee84ea4-c733-476b-8dd0-7b4aad63d426',
      name: 'Média defendendo lateral direita - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoLateralDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'da7bc57f-7508-4bcc-ab86-6b3cbb08470d',
      name: 'Média defendendo lateral esquerda - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.DefendendoLateralEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '222f673d-632b-45e8-b07f-ad9ee170c612',
      name: 'Média meio campo central - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MeioCampoCentralMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '83c4375b-9e31-47cb-bf94-0fd4f2c2b66e',
      name: 'Média meio campo direita - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MeioCampoDireitaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '80b56d92-ea80-470d-abbb-0579b84d05e4',
      name: 'Média meio campo esquerda - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MeioCampoEsquerdaMedia',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6d1b11d5-b6d9-47a7-86e8-1286af7815f6',
      name: 'Total jogos over 0,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '260faf5c-7f05-4880-88e6-b17ba105276b',
      name: 'Porcentagem jogos over 0,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '4699bd8f-28bf-4af4-908f-69454f45bd72',
      name: 'Total jogos over 1,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c9109ee4-494a-418a-84e6-273a214c8f1f',
      name: 'Porcentagem jogos over 1,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '895b80c9-c2b7-44fc-ae6a-9198ccb0d240',
      name: 'Total jogos over 2,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '41950f48-c58f-4ca4-98a1-1d3ee65e2f8a',
      name: 'Porcentagem jogos over 2,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ce68d6a4-0f5e-4907-b2c7-2c1f2e04bb5d',
      name: 'Total jogos over 3,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35TotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ad9e9f00-d845-43bc-a6b0-6c8abbf2cadf',
      name: 'Porcentagem jogos over 3,5 FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35PorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'd00b940b-980a-4937-a031-234e42eb1a97',
      name: 'Total jogos over 0,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0f3da1fc-4ef0-4979-b960-66d379e4c054',
      name: 'Porcentagem jogos over 0,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e75cb900-05c4-49a0-8372-337b09237981',
      name: 'Total jogos over 1,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7a2a51b8-688c-491b-aab1-9399687c89d9',
      name: 'Porcentagem jogos over 1,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'bc04dbbe-26d0-4052-a1e0-c6da22e9d4d2',
      name: 'Total jogos over 2,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '58b9e90d-8650-470b-947d-ec9a6b8a0ec4',
      name: 'Porcentagem jogos over 2,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cccbadbf-b530-4d0b-80a4-9ae6de043caa',
      name: 'Total jogos over 3,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35TotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7a1981e7-1f10-4839-9de4-528d3e6bbc31',
      name: 'Porcentagem jogos over 3,5 HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35PorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '420966f4-d7f0-4e51-993b-e373961eacd3',
      name: 'Total jogos BTTS sim FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f377316b-61e6-4dac-86be-dac73d29f089',
      name: 'Porcentagem jogos BTTS sim FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSPorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '7a09d99f-cec6-41df-9372-bdab38d15005',
      name: 'Total jogos BTTS sim HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1ed79853-6b52-4bc8-934e-d47b0944b981',
      name: 'Porcentagem jogos BTTS sim HT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSPorcentagemTotalHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1a0196f7-4073-4dd2-9a07-60d1194fa896',
      name: 'Total goleada FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoleadaTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '397a84ba-e99e-465d-93d8-3ba322efe897',
      name: 'Porcentagem goleada FT - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoleadaPorcentagemTotalFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cd881624-8d7a-47cb-a1e2-69b78131e0c5',
      name: 'Jogos over 0,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8950d2a7-2f9a-44b0-8411-af9b1e74897c',
      name: 'Porcentagem jogos over 0,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '850633a9-4366-42e7-86a1-9e45568b2ba6',
      name: 'Jogos over 1,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '24078cfa-bb13-4b77-814f-e059f56174da',
      name: 'Porcentagem jogos over 1,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '309a1f86-978f-4ea1-99e6-760b3f6b9ea7',
      name: 'Jogos over 2,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'cf7ee772-1661-438e-9e6c-8b88ab3d8a63',
      name: 'Porcentagem jogos over 2,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '38349b25-8023-420d-b43c-81d9a4b62f04',
      name: 'Jogos over 3,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35HomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2538d1d0-a0da-4ca6-936f-cf4369fc30c6',
      name: 'Porcentagem jogos over 3,5 FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35PorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '822634c9-0c28-45b4-a104-8b39b6f2338a',
      name: 'Jogos over 0,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '8d80d092-e277-4b2a-8186-59b0e94100e3',
      name: 'Porcentagem jogos over 0,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '758e4321-7dd1-4153-9ee6-714583643140',
      name: 'Jogos over 1,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2a7a9778-dab0-44c9-a414-c3f924f0b409',
      name: 'Porcentagem jogos over 1,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '80866aa7-46ce-468b-bf77-7bcb27135774',
      name: 'Jogos over 2,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3334444c-0627-4241-beb6-aced65ddfe63',
      name: 'Porcentagem jogos over 2,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '2bf29646-ad6f-47dc-8837-d2cab75dd3e8',
      name: 'Jogos over 3,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35HomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'c239f3ad-b96b-4ffd-8304-d95596476187',
      name: 'Porcentagem jogos over 3,5 HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35PorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ecd0bc75-580d-4aad-b45c-eff685973f2b',
      name: 'Jogos BTTS sim FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '28d5d071-8c59-4d9c-bb03-7b9ad042dbf8',
      name: 'Porcentagem jogos BTTS sim FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSPorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'af7a30b4-35fe-41e2-ab63-26bf23c45489',
      name: 'Jogos BTTS sim HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '6fc99abe-48a2-4408-b081-6662c4f01067',
      name: 'Porcentagem Jogos BTTS sim HT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSPorcentagemHomeHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ddbcdc01-8825-4885-ad9a-4085668a0193',
      name: 'Goleada FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoleadaHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '9f0e864f-ad77-4037-8ab1-f23d8aa9400a',
      name: 'Porcentagem goleada FT home - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoleadaPorcentagemHomeFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '032650bb-7db4-483c-b376-0d6a3f954715',
      name: 'Jogos over 0,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '34611dab-19e3-412f-b88f-69f739bfd008',
      name: 'Porcentagem jogos over 0,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '059f6b2a-d133-43ae-9c06-84bc63e1c399',
      name: 'Jogos over 1,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '018752fd-0561-4a56-ad06-514d748db0d4',
      name: 'Porcentagem jogos over 1,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '34fa70c8-87fb-4417-89ef-c01f2bdff1f8',
      name: 'Jogos over 2,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ddf83494-1505-49f3-80a7-b9f1bed88dab',
      name: 'Porcentagem jogos over 2,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '5d7a37e6-b27c-4ed2-a249-599f71052d7d',
      name: 'Jogos over 3,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35AwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '3af7b17c-a811-44ba-8866-e2eb3ad6d0fe',
      name: 'Porcentagem jogos over 3,5 FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35PorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '054c47b2-8be4-481f-b5cc-98c7af99fb6b',
      name: 'Jogos over 0,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '52243ae4-2ffd-439e-aa48-bf35279c8a92',
      name: 'Porcentagem jogos over 0,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver05PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '386a975c-3b3f-45c3-b625-6e81d2956237',
      name: 'Jogos over 1,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '43d98701-291b-48bc-b369-9db445fa8d7b',
      name: 'Porcentagem jogos over 1,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver15PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '44959f72-c5a2-4306-8bb6-e23f42bc8aaf',
      name: 'Jogos over 2,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '1732a96b-b5b4-4aaa-8b0b-5f6cb5ac819a',
      name: 'Porcentagem jogos over 2,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver25PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'a55a83f0-4297-4511-9a37-602aee051b08',
      name: 'Jogos over 3,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35AwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'ba282e4b-b8fb-4ca3-a555-1b9c94f1d97a',
      name: 'Porcentagem jogos over 3,5 HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosOver35PorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'e9616917-07a7-4d13-80ce-6d6b569fa411',
      name: 'Jogos BTTS sim FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '67c832d3-d4fc-4814-8ddb-58765ac5ce85',
      name: 'Porcentagem jogos BTTS sim FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSPorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '0e66a008-c337-48e8-a2d3-22a2c48d5aab',
      name: 'Jogos BTTS sim HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '87d8ba4d-f8a9-40ab-a376-cd04f2f52d0f',
      name: 'Porcentagem jogos BTTS sim HT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.JogosBTTSPorcentagemAwayHT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'f124ec84-f621-457f-afca-1b60d5fab7ac',
      name: 'Goleada FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoleadaAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: '20cea30a-4685-49d1-92ce-03b43105f206',
      name: 'Porcentagem goleada FT away - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.GoleadaPorcentagemAwayFT',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b7725',
      name: 'Marcou primeiro gol total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b7686',
      name: 'Porcentagem marcou primeiro gol total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b8307',
      name: 'Marcou primeiro gol venceu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolVenceuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b7048',
      name: 'Porcentagem marcou primeiro gol venceu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolVenceuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b6549',
      name: 'Marcou primeiro gol perdeu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolPerdeuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b91810',
      name: 'Porcentagem marcou primeiro gol perdeu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolPerdeuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b29611',
      name: 'Marcou primeiro gol empatou total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolEmpatouTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b82412',
      name: 'Porcentagem marcou primeiro gol empatou total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolEmpatouTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b51813',
      name: 'Marcou primeiro gol jogando casa - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b17614',
      name: 'Porcentagem marcou primeiro gol jogando casa - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b57415',
      name: 'Marcou primeiro gol jogando casa venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolVenceuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b27516',
      name: 'Porcentagem marcou primeiro gol jogando casa venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolVenceuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b48717',
      name: 'Marcou primeiro gol jogando casa perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolPerdeuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b67018',
      name: 'Porcentagem marcou primeiro gol jogando casa perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolPerdeuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b38019',
      name: 'Marcou primeiro gol jogando casa empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolEmpatouHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b56220',
      name: 'Porcentagem marcou primeiro gol jogando casa empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolEmpatouHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b41221',
      name: 'Marcou primeiro gol jogando fora - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b21022',
      name: 'Porcentagem marcou primeiro gol jogando fora - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b14223',
      name: 'Marcou primeiro gol jogando fora venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolVenceuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b86924',
      name: 'Porcentagem marcou primeiro gol jogando fora venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolVenceuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b37025',
      name: 'Marcou primeiro gol jogando fora perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolPerdeuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b9226',
      name: 'Porcentagem marcou primeiro gol jogando fora perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolPerdeuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b70527',
      name: 'Marcou primeiro gol jogando fora empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolEmpatouAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b42228',
      name: 'Porcentagem marcou primeiro gol jogando fora empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.MarcouPrimeiroGolEmpatouAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b51229',
      name: 'Sofreu primeiro gol total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b230',
      name: 'Porcentagem sofreu primeiro gol total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b83631',
      name: 'Sofreu primeiro gol venceu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolVenceuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b28732',
      name: 'Porcentagem sofreu primeiro gol venceu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolVenceuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b5333',
      name: 'Sofreu primeiro gol perdeu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolPerdeuTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b46534',
      name: 'Porcentagem sofreu primeiro gol perdeu total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolPerdeuTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b97235',
      name: 'Sofreu primeiro gol empatou total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolEmpatouTotal',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b34636',
      name: 'Porcentagem sofreu primeiro gol empatou total - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolEmpatouTotalPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b60237',
      name: 'Sofreu primeiro gol jogando casa - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b73738',
      name: 'Porcentagem sofreu primeiro gol jogando casa - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b19539',
      name: 'Sofreu primeiro gol jogando casa venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolVenceuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b27840',
      name: 'Porcentagem sofreu primeiro gol jogando casa venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolVenceuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b56041',
      name: 'Sofreu primeiro gol jogando casa perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolPerdeuHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b71542',
      name: 'Porcentagem sofreu primeiro gol jogando casa perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolPerdeuHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b17943',
      name: 'Sofreu primeiro gol jogando casa empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolEmpatouHome',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b4344',
      name: 'Porcentagem sofreu primeiro gol jogando casa empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolEmpatouHomePorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b46845',
      name: 'Sofreu primeiro gol jogando fora - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b53346',
      name: 'Porcentagem sofreu primeiro gol jogando fora - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b44647',
      name: 'Sofreu primeiro gol jogando fora venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolVenceuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b99148',
      name: 'Porcentagem sofreu primeiro gol jogando fora venceu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolVenceuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b76949',
      name: 'Sofreu primeiro gol jogando fora perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolPerdeuAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b66250',
      name: 'Porcentagem sofreu primeiro gol jogando fora perdeu - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolPerdeuAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b95151',
      name: 'Sofreu primeiro gol jogando fora empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolEmpatouAway',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }, {
      id: 'b26f9330-1bde-4256-9c13-07065941a73b96252',
      name: 'Porcentagem sofreu primeiro gol jogando fora empatou - VISITANTE',
      type: 'integer',
      jsonMap: 'preLiveAway.SofreuPrimeiroGolEmpatouAwayPorcentagem',
      dataType: 'behavior',
      access: [7, 8, 9, 15, 111, 112]
    }];
    this.anroldMapHome = this.arnoldInputsHome.map(function (el) {
      el.inputType = 'arnold';
      return el;
    });
    this.anroldMapAway = this.arnoldInputsAway.map(function (el) {
      el.inputType = 'arnold';
      return el;
    });
    this.arnoldInputs = __spreadArrays(this.anroldMapHome, this.anroldMapAway);
    this.methodsInputs = __spreadArrays([{
      id: 'add4d604-dcb4-423e-bea9-c97a0235a927',
      name: 'Tempo de jogo',
      type: 'integer',
      jsonMap: 'time3',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a689826c-39b3-4d68-b964-9d3499e72191',
      name: 'ID do torneio',
      type: 'string',
      jsonMap: 'game_infos.tournament_id',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3b4f2961-8bee-4691-94ef-07bab79c5dd3',
      name: 'ID time casa',
      type: 'string',
      jsonMap: 'competitors[0].id',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '29213dee-fcbd-4c33-a7a2-00947fe2f701',
      name: 'ID time visitante',
      type: 'string',
      jsonMap: 'competitors[1].id',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '8369d8e3-efc6-471a-b086-454980c055c6',
      name: 'Chutes casa C1',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[0]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3876e688-5ca8-41f1-bbd0-e34df564b045',
      name: 'Chutes casa C2',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[1]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '071732b4-5a44-40f2-93c2-6ac6bd0a1cd3',
      name: 'Chutes casa C3',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[2]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '94ff4311-95a4-4ec9-80ae-fa67e0ad2cad',
      name: 'Chutes casa C4',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[3]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '036bd958-2b16-4829-a65f-53c057dcb080',
      name: 'Chutes casa C5',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[4]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'baaa8433-781c-49cf-928d-7b3ff3b93482',
      name: 'Chutes visitante C1',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[5]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '71fcdb96-cfd9-4609-9527-71d1349c0ff3',
      name: 'Chutes visitante C2',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[6]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '45f7266b-88e5-4413-88c0-4e30517896cd',
      name: 'Chutes visitante C3',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[7]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0d569f8c-7684-4833-ba1f-9ffcbac32154',
      name: 'Chutes visitante C4',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[8]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '04f83794-d4d7-461b-8a4f-d0e61b03c04f',
      name: 'Chutes visitante C5',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[9]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6b286902-6836-4dd5-8c47-21532d9d26c3',
      name: 'Total chutes C1',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[10]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f24e75c1-9eb7-4f31-bbfc-142eded293a6',
      name: 'Total chutes C2',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[11]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '633826d6-1f6f-430d-b792-e086319532c1',
      name: 'Total chutes C3',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[12]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9c71f742-58ae-4c2b-abd3-25adc97f5521',
      name: 'Total chutes C4',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[13]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '319c58a6-6344-471c-98a3-2e1b8bcd2b95',
      name: 'Total chutes C5',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[14]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b7395476-a3ca-4808-91d7-423c0eaa8a26',
      name: 'Chutes casa C1 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[15]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a69a7958-eb0b-4cf2-94ff-d72ee7364c93',
      name: 'Chutes casa C2 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[16]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'effb5025-78b9-4e26-b509-1b80403c7f0f',
      name: 'Chutes casa C3 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[17]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'e0ea041d-6e44-4300-b73d-787468da59bb',
      name: 'Chutes casa C4 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[18]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '22882681-8cac-44c7-b744-4cc6cf47e0c4',
      name: 'Chutes casa C5 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[19]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '67f25879-531f-4c58-a2fb-4e48ee644f58',
      name: 'Chutes visitante C1 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[20]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b3427437-1d32-43f7-a037-02cf169a957d',
      name: 'Chutes visitante C2 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[21]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c4811491-6c17-44bc-9ff6-7643d88f88d3',
      name: 'Chutes visitante C3 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[22]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '90cc784f-5629-4da2-b0a9-19bbaf39df06',
      name: 'Chutes visitante C4 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[23]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '59d1c782-17bd-41f4-93fe-effe2d7372b4',
      name: 'Chutes visitante C5 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[24]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0e1c2b50-cbd8-4f2c-b9d0-da1e91e9e986',
      name: 'Total chutes C1 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[25]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9521d4cb-405a-4deb-b6d5-bef2d4482acf',
      name: 'Total chutes C2 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[26]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '7a2cef16-fb96-41a1-b0bc-b661ea51f36d',
      name: 'Total chutes C3 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[27]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '2c75534e-9da6-4326-b98a-dfe20417f2b7',
      name: 'Total chutes C4 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[28]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9bf1a96d-1720-4789-abca-ab1b616c03ee',
      name: 'Total chutes C5 no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[29]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd69445e6-9de3-4666-bbd6-a9d1d06d289c',
      name: 'Total chutes casa no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[30]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f13bf821-b15b-42a1-94ac-2c49a31a1f00',
      name: 'Total chutes visitante no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[31]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'fae09fde-e28e-4e0f-9756-5b754ec52b2c',
      name: 'Total chutes no gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[32]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b512ad87-9b71-4b92-8244-45a5de96ec8b',
      name: 'Chutes casa C1 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[33]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd268aba9-68aa-48c5-8ac4-90cd6bc627e4',
      name: 'Chutes casa C2 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[34]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b8da3c1a-87f0-4abd-a263-1c3cff79c692',
      name: 'Chutes casa C3 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[35]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b8784b56-be6f-4644-b8dc-513c0a658bd0',
      name: 'Chutes casa C4 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[36]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ff2aed29-66b0-4d65-8ab8-44da1259b16c',
      name: 'Chutes casa C5 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[37]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'bc10aed4-e8ce-486a-938d-7cec52804f42',
      name: 'Chutes visitante C1 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[38]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3b8ff94b-222e-41f4-9371-5f4c6e4e2797',
      name: 'Chutes visitante C2 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[39]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3ddfd3b6-dd8a-4825-b3d4-2888506adba1',
      name: 'Chutes visitante C3 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[40]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'da165e36-78c6-474e-8a50-06bc44b38d23',
      name: 'Chutes visitante C4 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[41]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '09b3afca-e739-442a-8e1d-a7e6cab5d397',
      name: 'Chutes visitante C5 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[42]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '03f9ca5e-1df0-4a75-8ddb-1ffe9464f7a7',
      name: 'Total chutes C1 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[43]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9029fb9e-b470-4be0-9f5f-ceeeb4a40f53',
      name: 'Total chutes C2 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[44]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '44eec338-6607-4bf7-8270-a43a7f5a83b5',
      name: 'Total chutes C3 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[45]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '311c65eb-d8e8-4a3c-b1fe-8402a4836bad',
      name: 'Total chutes C4 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[46]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a03647e1-fbf3-4b63-8303-185b202567c3',
      name: 'Total chutes C5 fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[47]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '7bc12641-58eb-4b64-89ce-9e7a76ac5702',
      name: 'Total chutes casa fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[48]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'bd0cb742-492d-4a4c-8466-4d8ffd93d725',
      name: 'Total chutes visitante fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[49]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6fcea2f6-4131-488a-9c9b-e9c0b16d4075',
      name: 'Total chutes fora do gol',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[50]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'af846bb1-c3da-40b4-bcb5-ac779ec6de67',
      name: 'Chutes salvos casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[51]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '94110f8a-8452-4adc-b25c-8fae9bf450ca',
      name: 'Chutes salvos visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[52]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '95c15e11-8895-4a16-95f2-ec5855a7393b',
      name: 'Total chutes salvos',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[53]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f86ba616-ffcc-497a-97ee-a2b91c444bfa',
      name: 'Total chutes',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[54]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asjk1230-akjds1-497a-987aks9',
      name: 'Total chutes casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[91]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhklaj-123jkh-sa786-ffcc1sd1',
      name: 'Total chutes visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[92]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhxfcc1sd11',
      name: 'Total Chutes c1c2c3 Casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[93]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhxfcc1sd12',
      name: 'Total Chutes c1c2c3 Visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[94]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhxfcc1sd13',
      name: 'Total Chutes c1c2c3 Total',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[95]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhxfcc1sd14',
      name: 'Total Chutes No Gol c1c2c3 Casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[96]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhxfcc1sd15',
      name: 'Total Chutes No Gol c1c2c3 Visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[97]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'asdjhxfcc1sd16',
      name: 'Total Chutes No Gol c1c2c3 Total',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[98]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9425eea6-6aa1-4d48-b87e-6c0601ceb297',
      name: 'Chutes dentro da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[55]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '7cdd4d0d-6954-46c8-83c7-be07596eac1d',
      name: 'Chutes dentro da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[56]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0f6ec89e-8c01-4875-8851-cffd539303b3',
      name: 'Chutes no gol dentro da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[57]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6d8e5e33-2fb1-478c-b9fd-a52cadb18695',
      name: 'Chutes no gol dentro da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[58]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5e21e7a5-3d1b-4236-b21f-2143c7508203',
      name: 'Chutes fora do gol dentro da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[59]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '23acc74a-cef2-4ace-aae5-4701cf17c9e3',
      name: 'Chutes fora do gol dentro da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[60]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'aab5db6d-a5d1-41d7-b43d-b222d826808b',
      name: 'Total chutes dentro da area',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[61]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3e7ff0b8-518c-4fab-92dd-7e71e1e6795e',
      name: 'Total chutes no gol dentro da area',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[62]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '227348ad-3971-41cc-ba26-13646d5faa1c',
      name: 'Total chutes fora do gol dentro da area',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[63]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '733e1ed9-4d34-4051-8f72-45248bcd6ecf',
      name: 'Escanteios casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[64]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '58986062-440b-4b0f-ac79-098ef702466f',
      name: 'Escanteios visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[65]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '51367f4a-59a5-4ce4-afdf-058e2038626e',
      name: 'Total escanteios',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[66]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'eec033b7-fb69-4227-83e7-42822d6c3c6e',
      name: 'Laterais casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[67]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'e5f5ebbe-ea8e-4e50-b43b-59f8b1c27478',
      name: 'Laterais visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[68]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9e30f6b0-d21a-42c4-8a44-304f805f521a',
      name: 'Total laterais',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[69]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b3638a50-b6b7-48ea-923a-a3b7fa4b1950',
      name: 'Cartoes amarelos casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[70]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '245eb361-a582-4780-95be-31e7109f91d8',
      name: 'Cartoes amarelos visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[71]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '71420408-57c7-4edc-a0c2-de69aef7978d',
      name: 'Total cartoes amarelos',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[72]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f25845f8-3989-4b87-beaf-03547f537275',
      name: 'Cartoes vermelhos casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[73]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '34f07f87-78fa-4e81-930f-ac066eaf866e',
      name: 'Cartoes vermelhos visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[74]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6776642c-7ac1-4247-8a39-720d6a862e41',
      name: 'Total cartoes vermelhos',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[75]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0f9a9a32-eaca-4e1a-ba29-583202af306d',
      name: 'Impedimentos casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[76]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a10c1c2e-f10d-4d30-a7df-65aa00d203b6',
      name: 'Impedimentos visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[77]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f0c752bd-a2c1-4ab0-a64f-6a3b47fdd4f8',
      name: 'Total impedimentos',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[78]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ec50d924-da90-437a-b1e7-54bb55247ab6',
      name: 'Tiros de meta casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[79]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b0c07fcc-1a43-43ae-a74f-4097df71f427',
      name: 'Tiros de meta visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[80]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '578ab449-163e-41c6-92d4-272236b469df',
      name: 'Total tiros de meta',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[81]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '20bf7c20-5efd-407d-8f90-ace1e9f67f6a',
      name: 'Tiros livres casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[82]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a79185fe-d939-4a88-a47f-48fbf7980c8a',
      name: 'Tiros livres visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[83]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '02e1d504-7668-4a95-9fb3-ff3362bf3148',
      name: 'Total tiros livres',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[84]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'e3841e70-6e76-4d21-a756-4dff02799a9b',
      name: 'Gols casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[85]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '61ee28c7-11b8-497c-8635-1728bf44906e',
      name: 'Gols visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[86]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '02e94497-4299-4485-9d4b-d27d55c85f1a',
      name: 'Total gols',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[87]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'e3841e70-6e76-4daa98123aklsdajkj121-a756',
      name: 'Gols casa 1º tempo',
      type: 'integer',
      jsonMap: 'competitors[0].home_score_1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6asdc7-11asd123b-497c-8635-1728bf1231sd44',
      name: 'Gols visitante 1º tempo',
      type: 'integer',
      jsonMap: 'competitors[1].away_score_1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '02easdas-7adasdadasd9-*55c85f1a',
      name: 'Total gols 1º tempo',
      type: 'integer',
      jsonMap: 'gols1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '561eba03-8941-4884-9669-685e20306846',
      name: 'Penaltis casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[88]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '51c6a268-b0e7-474f-a56c-87047069cc19',
      name: 'Penaltis visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[89]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '60860a71-04ae-4e11-9b27-30a579bdfaaf',
      name: 'Total penaltis',
      type: 'integer',
      jsonMap: 'game_infos.statistics_kicks_total[90]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '7d3ef35e-0f53-4a98-b687-29298bf4cd40',
      name: 'Ataques perigosos casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[0]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '8ff4e90a-054f-4f20-9b12-dcf0ff25d12c',
      name: 'Ataques perigosos visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[1]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '26a8c01c-e50a-4999-ac97-b3eb12c6980c',
      name: 'Zona de perigo casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[2]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '56f3e11a-fe58-423b-bb61-a794ffd77cc1',
      name: 'Zona de perigo visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[3]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '7f424411-bbe8-45b5-9353-8a1e1b2c23e8',
      name: 'Atacando dentro da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[4]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '44fa7f8a-b95d-4909-9f6e-b84fb518ee3c',
      name: 'Atacando dentro da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[25]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0cd214a6-f47b-4809-aa0a-5c57d41acf50',
      name: 'Atacando diagonal direita casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[5]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3dd620b8-4e61-45a4-8f82-dbec76697ae6',
      name: 'Atacando diagonal direita visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[26]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '2780312a-e76b-4c07-96a8-75dda5f4d115',
      name: 'Atacando diagonal esquerda casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[6]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b9541b39-7b41-421a-9bf0-2a5399dcd75d',
      name: 'Atacando diagonal esquerda visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[27]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'bdb90201-9400-4cd5-8e36-6c7dde7c77d4',
      name: 'Atacando frente da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[7]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '981353ba-cd2f-405f-a16f-75ec41480d33',
      name: 'Atacando frente da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[28]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ca4158c0-4096-4ac8-afb0-624da7ac859b',
      name: 'Atacando fundo lado direito casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[8]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '93ce1a99-69a6-423f-9ead-0feb98e6790c',
      name: 'Atacando fundo lado direito visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[29]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '556e1618-3568-4deb-8374-a5585a8f3797',
      name: 'Atacando fundo lado esquerdo casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[9]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b7c7157b-6fe6-4a8f-afba-89005c612ad2',
      name: 'Atacando fundo lado esquerdo visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[30]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '363c94aa-008b-49b8-b621-a2fb964f0b77',
      name: 'Atacando intermediaria casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[10]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f626cff5-c7ad-4d3a-aea3-47966a584199',
      name: 'Atacando intermediaria visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[31]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ad2458c9-8cf9-4be1-b997-77a427d3dad8',
      name: 'Atacando lateral direita casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[11]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6a3d892d-c6e5-4b99-b47d-f3b87c315a73',
      name: 'Atacando lateral direita visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[32]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'dc96ba91-4d7e-40c4-bde1-ccbdeba37480',
      name: 'Atacando lateral esquerda casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[12]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'cfe52a30-12ec-4711-8dcf-d847d9756820',
      name: 'Atacando lateral esquerda visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[33]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'dfbef39a-2723-439f-b2d5-558e87b4c957',
      name: 'Defendendo dentro da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[13]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'dd9958d3-63d3-4bb0-86c7-9fa40c510ecc',
      name: 'Defendendo dentro da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[34]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f84fe0fb-1771-4462-a2f7-f5d905d5cce7',
      name: 'Defendendo diagonal direita casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[14]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a17c2a77-cb77-4bb4-8473-bae34217fe5f',
      name: 'Defendendo diagonal direita visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[35]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0cff39f0-d449-4208-a0ab-637c9d452d50',
      name: 'Defendendo diagonal esquerda casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[15]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9e928def-ab52-4784-b804-c19a811cbf15',
      name: 'Defendendo diagonal esquerda visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[36]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '468529bf-a935-47e9-8c7a-ce2146683588',
      name: 'Defendendo frente da area casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[16]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '835cef28-dd32-4a08-97b3-f8d259894ef5',
      name: 'Defendendo frente da area visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[37]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0e8de598-9fd3-4fdd-acd0-b9bfb72168c1',
      name: 'Defendendo fundo lado direito casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[17]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'daefa4c1-04eb-4602-a327-6d1d64a30435',
      name: 'Defendendo fundo lado direito visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[38]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3c7f4d03-0675-49c3-b147-6f29e4b104ab',
      name: 'Defendendo fundo lado esquerdo casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[18]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b095a354-fc21-417a-b52d-7501ca8069f9',
      name: 'Defendendo fundo lado esquerdo visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[39]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c02eaa7a-b226-4aa3-b97f-7dae5c9ebc75',
      name: 'Defendendo intermediaria casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[19]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '53dd3835-e8b6-45d9-a32f-83a09783a380',
      name: 'Defendendo intermediaria visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[40]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9add02d5-275d-4d92-b20a-94084491205b',
      name: 'Defendendo lateral direita casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[20]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '9fc1b553-3e3e-461b-9d3a-0c90fb58a0de',
      name: 'Defendendo lateral direita visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[41]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '97797aeb-6497-477f-81a2-1dd185da41c5',
      name: 'Defendendo lateral esquerda casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[21]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd7750cd1-92f5-4f4a-ac0b-94f0d8a98745',
      name: 'Defendendo lateral esquerda visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[42]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3985385b-4dd6-44de-8229-65d42ccf1bed',
      name: 'Meio campo central casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[22]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '1d96d760-c6d5-4460-b1cd-b0f4c6ee254e',
      name: 'Meio campo central visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[43]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a24668b6-dfa7-44e4-aa40-e34332c388ff',
      name: 'Meio campo direita casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[23]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f525da43-558b-4e9a-9cc1-f416e96c0bc3',
      name: 'Meio campo direita visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[44]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'e3ec5eb7-d716-4a7c-bb07-1972fdc04f61',
      name: 'Meio campo esquerda casa',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[24]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4d950a86-beed-4799-934e-27d144fdb946',
      name: 'Meio campo esquerda visitante',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[45]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '318dce24-0488-4bf5-9577-831fdddae67b',
      name: 'Posse de bola casa',
      type: 'integer',
      jsonMap: 'competitors[0].statistics.ball_possession',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5a42abc5-ef0c-4fdf-aee5-5e746ad11f8e',
      name: 'Posse de bola visitante',
      type: 'integer',
      jsonMap: 'competitors[1].statistics.ball_possession',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '189f9a1f-7b7f-4283-bce3-9bb2fad97c2a',
      name: 'Faltas casa',
      type: 'integer',
      jsonMap: 'competitors[0].statistics.fouls',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '71cfa80d-7202-4aca-a1c6-44cfe1fa16f0',
      name: 'Faltas visitante',
      type: 'integer',
      jsonMap: 'competitors[1].statistics.fouls',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '6c4ca8be-65a6-49f2-a344-ad7c81c370ad',
      name: 'Chutes bloqueados casa',
      type: 'integer',
      jsonMap: 'competitors[0].statistics.shots_blocked',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e35e-46ed-830c-98ba01ce01a9',
      name: 'Chutes bloqueados visitante',
      type: 'integer',
      jsonMap: 'competitors[1].statistics.shots_blocked',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e3asdasd5e-46ed-ce01a99',
      name: 'Chutesc1c2c3 10min - Casa',
      type: 'integer',
      jsonMap: 'ult10.chutesc1c2c3Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e3asdasd5e-46ed-ce01a912',
      name: 'Chutesc1c2c3 10min - Visitante',
      type: 'integer',
      jsonMap: 'ult10.chutesc1c2c3Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e3asdasd5e-46ed-ce01a914',
      name: 'Chutesc1c2c3 No Gol 10min - Casa',
      type: 'integer',
      jsonMap: 'ult10.chutesNoGolc1c2c3Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e3asdasd5e-46ed-ce01a915',
      name: 'Chutesc1c2c3 No Gol 10min - Visitante',
      type: 'integer',
      jsonMap: 'ult10.chutesNoGolc1c2c3Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e3asdasd5e-46ed-ce01a93',
      name: 'Chutesc1c2c3 10min - Total',
      type: 'integer',
      jsonMap: 'ult10.chutesc1c2c3Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5d0a086c-e3asdasd5e-46ed-ce01a96',
      name: 'Chutesc1c2c3 No Gol 10min - Total',
      type: 'integer',
      jsonMap: 'ult10.chutesNoGolc1c2c3Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'fedd55f5-3569-48a8-b572-0d276479cea9',
      name: 'Pressão 1 casa',
      type: 'integer',
      jsonMap: 'competitors[0].pl1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b084eafb-f2a5-4ea5-8442-f307852194fe',
      name: 'Pressão 2 casa',
      type: 'integer',
      jsonMap: 'competitors[0].pl2',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '2d2074ef-8784-497d-b8b7-4733b72d070d',
      name: 'Pressão 1 visitante',
      type: 'integer',
      jsonMap: 'competitors[1].pl1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '19855c89-c8b6-41d8-8dcb-02a49c9fa177',
      name: 'Pressão 2 visitante',
      type: 'integer',
      jsonMap: 'competitors[1].pl2',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '198-asdh18casdb6-2asd1a41239',
      name: 'Pressão 1 total',
      type: 'integer',
      jsonMap: 'game_infos.pl1Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '104cas123--9easd123df-23c0e6ar923s',
      name: 'Pressão 2 total',
      type: 'integer',
      jsonMap: 'game_infos.pl2Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd8004-123123789ajkhdsakhj189321*as23',
      name: 'Acréscimos 1 tempo',
      type: 'integer',
      jsonMap: 'injury1_injury',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd8aasd786123asdjl123ASD12323',
      name: 'Acréscimos 2 tempo',
      type: 'integer',
      jsonMap: 'injury2_injury',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '10470b9c-22b4-4233-9edf-2612793c0e69',
      name: 'Nivel dados',
      type: 'string',
      jsonMap: 'game_infos.coverage_info_level',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5123s940487f-123sdasdjklaj123908-1jlsad90123',
      name: 'Rodada do campeonato',
      type: 'integer',
      jsonMap: 'game_infos.tournament_round_number',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5940487f-b4ae-4364-ac97-1a2a8863fb52',
      name: 'Posição na tabela Casa',
      type: 'integer',
      jsonMap: 'competitors[0].group_position',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'b664163e-05b2-413e-8786-68b20f085798',
      name: 'Posição na tabela Visitante',
      type: 'integer',
      jsonMap: 'competitors[1].group_position',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c10b986d-2da1-46e9-bc91-d9fe10a739ae',
      name: 'Numero de vitorias no campeonato Casa',
      type: 'integer',
      jsonMap: 'competitors[0].matches_won',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '1f8fea6e-c9d4-4b2c-9217-9454a006f61c',
      name: 'Numero de vitorias no campeonato Visitante',
      type: 'integer',
      jsonMap: 'competitors[1].matches_won',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd1ab9a40-b8d9-42dc-8fe4-13a8d649afe6',
      name: 'Numero de empates no campeonato Casa',
      type: 'integer',
      jsonMap: 'competitors[0].matches_drawn',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'a6f3a195-619c-4c44-b127-de471fda78ff',
      name: 'Numero de empates no campeonato Visitante',
      type: 'integer',
      jsonMap: 'competitors[1].matches_drawn',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '3f2b3152-4919-414c-a36f-329abaf47a74',
      name: 'Numero de derrotas no campeonato Casa',
      type: 'integer',
      jsonMap: 'competitors[0].matches_lost',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd50ca016-ff52-432f-9cff-9578bbb1b9ec',
      name: 'Numero de derrotas no campeonato Visitante',
      type: 'integer',
      jsonMap: 'competitors[1].matches_lost',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '535f6d7b-325b-4af0-b465-7e0195621c9a',
      name: 'Gols marcados no campeonato Casa',
      type: 'integer',
      jsonMap: 'competitors[0].goals_scored',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '84e2b92b-b20e-47d4-afad-8a16c8661f51',
      name: 'Gols marcados no campeonato Visitante',
      type: 'integer',
      jsonMap: 'competitors[1].goals_scored',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '884aef85-704e-4ab7-ad7f-dc0720c988f6',
      name: 'Gols sofridos no campeonato Casa',
      type: 'integer',
      jsonMap: 'competitors[0].goals_conceded',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd5335f79-325d-41fd-a1d7-036464168004',
      name: 'Gols sofridos no campeonato Visitante',
      type: 'integer',
      jsonMap: 'competitors[1].goals_conceded',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'daasd*9795-*9ad8*4168004',
      name: 'Elo rating casa',
      type: 'integer',
      jsonMap: 'competitors[0].eloRating',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd8004-123907130aksdjakd-123123*askdajkdh123',
      name: 'Elo rating visitante',
      type: 'integer',
      jsonMap: 'competitors[1].eloRating',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f7aa64ed-495f-4840-a8f0-8c17b79d9b83',
      name: 'id1',
      type: 'integer',
      jsonMap: 'game_infos.full47Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '10a10fe0-f4f6-4dd2-8206-8e5c814d1038',
      name: 'id2',
      type: 'integer',
      jsonMap: 'game_infos.full47Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd655b34c-5f7d-4224-81ee-c7d3d27e4583',
      name: 'ad1',
      type: 'integer',
      jsonMap: 'game_infos.ad51Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '904629ba-7ae9-4846-8884-0580d246af20',
      name: 'ad2',
      type: 'integer',
      jsonMap: 'game_infos.ad51Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '581fb770-07e6-43aa-9d98-59f7f5898806',
      name: 'ad3',
      type: 'integer',
      jsonMap: 'game_infos.ad51',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '581fb7789-asd8912-3*aa12342',
      name: 'Gols no último 1 minuto',
      type: 'integer',
      jsonMap: 'lastGols.gols1min',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '581fb770-07e6-9d989asd89123*asd71834a12342',
      name: 'Gols nos últimos 2 minutos',
      type: 'integer',
      jsonMap: 'lastGols.gols2min',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '581fb770-07e6-9d9898as534a12342',
      name: 'Gols nos últimos 3 minutos',
      type: 'integer',
      jsonMap: 'lastGols.gols3min',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '581f412370--8as534a12342',
      name: 'Gols nos últimos 5 minutos',
      type: 'integer',
      jsonMap: 'lastGols.gols5min',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748sa71239',
      name: 'Gols nos últimos 10 minutos',
      type: 'integer',
      jsonMap: 'lastGols.gols10min',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712131',
      name: 'Aceleração 0 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace0Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a37481239088671213',
      name: 'Aceleração 1 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace1Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712132',
      name: 'Aceleração 2 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace2Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712133',
      name: 'Aceleração 3 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace3Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712134',
      name: 'Aceleração 4 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace4Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712135',
      name: 'Aceleração 5 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace5Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as521361',
      name: 'Aceleração 0 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace0Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712136',
      name: 'Aceleração 1 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace1Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748123908867121327',
      name: 'Aceleração 2 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace2Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748123908867121338',
      name: 'Aceleração 3 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace3Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748123908867121349',
      name: 'Aceleração 4 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace4Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a37481239088671213510',
      name: 'Aceleração 5 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace5Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as5213612',
      name: 'Aceleração 0 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace0Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748123908867121361',
      name: 'Aceleração 1 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace1Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a37481239088671213272',
      name: 'Aceleração 2 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace2Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a37481239088671213383',
      name: 'Aceleração 3 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace3Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a37481239088671213494',
      name: 'Aceleração 4 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace4Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712135105',
      name: 'Aceleração 5 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace5Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as52136123',
      name: 'Aceleração 0-2 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace02Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a374812390886712134941',
      name: 'Aceleração 1-3 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace13Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as521361234',
      name: 'Aceleração 0-4 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace04Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748123908867121351052',
      name: 'Aceleração 1-5 Casa',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace15Casa',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as5213612345',
      name: 'Aceleração 0-2 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace02Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a3748123908867121349413',
      name: 'Aceleração 1-3 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace13Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as52136123456',
      name: 'Aceleração 0-4 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace04Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as534a37481239088671213510524',
      name: 'Aceleração 1-5 Visitante',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace15Visitante',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as521361234567',
      name: 'Aceleração 0-2 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace02Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--1235123239088671213494131',
      name: 'Aceleração 1-3 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace13Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as5213612345678',
      name: 'Aceleração 0-4 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace04Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--12351232390886712135105242',
      name: 'Aceleração 1-5 Total',
      type: 'integer',
      jsonMap: 'graphsIndicators.ace15Total',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as52136123456789',
      name: 'Diferença Aceleração CasaVisitante 0',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante0',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--12351351052421',
      name: 'Diferença Aceleração CasaVisitante 1',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--12351351052422',
      name: 'Diferença Aceleração CasaVisitante 2',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante2',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--12351351052423',
      name: 'Diferença Aceleração CasaVisitante 3',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante3',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--12351351052424',
      name: 'Diferença Aceleração CasaVisitante 4',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante4',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--12351351052425',
      name: 'Diferença Aceleração CasaVisitante 5',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante5',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as5213612345678910',
      name: 'Diferença Aceleração VisitanteCasa 0',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa0',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--123513510524216',
      name: 'Diferença Aceleração VisitanteCasa 1',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa1',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--123513510524227',
      name: 'Diferença Aceleração VisitanteCasa 2',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa2',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--123513510524238',
      name: 'Diferença Aceleração VisitanteCasa 3',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa3',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--123513510524249',
      name: 'Diferença Aceleração VisitanteCasa 4',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa4',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--1235135105242510',
      name: 'Diferença Aceleração VisitanteCasa 5',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa5',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as52136123456789101',
      name: 'Diferença Aceleração CasaVisitante 0-2',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante02',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50as3i5--1235135105242510121',
      name: 'Diferença Aceleração CasaVisitante 1-3',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante13',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as521361234567891012',
      name: 'Diferença Aceleração CasaVisitante 0-4',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante04',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50as3i5--1235135105242510122',
      name: 'Diferença Aceleração CasaVisitante 1-5',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceCasaVisitante15',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as52136123456789101233',
      name: 'Diferença Aceleração VisitanteCasa 0-2',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa02',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50as3i5--1235135105242510123',
      name: 'Diferença Aceleração VisitanteCasa 1-3',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa13',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50asdu123i5--8as521361234567891012334',
      name: 'Diferença Aceleração VisitanteCasa 0-4',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa04',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '50as3i5--1235135105242510124',
      name: 'Diferença Aceleração VisitanteCasa 1-5',
      type: 'integer',
      jsonMap: 'graphsIndicators.diffAceVisitanteCasa15',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '26a8c01c-e50a-4999-ac97-b3eb12c6980c1ad1',
      name: 'Zona de perigo total',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[46]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '26a8c01c-e50a-4999-ac97-b3eb12c6980c1ad12',
      name: 'Atacando dentro da area total',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[47]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '26a8-b3e12380c1ad12-asdjh123897as',
      name: 'Atacando frente da area total',
      type: 'integer',
      jsonMap: 'game_infos.statistics_position_total[48]',
      dataType: 'behavior',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '390cf3bd-aaa6-4b59-89aa-da60ab005d8a',
      name: 'Odd Inicial - Match Odds back casa',
      type: 'integer',
      jsonMap: 'initialOdds[\'match odds-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f2e99bfa-1fa4-4e4a-a4f5-aae695ca8c14',
      name: 'Odd Inicial - Match Odds lay casa',
      type: 'integer',
      jsonMap: 'initialOdds[\'match odds-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c23815d4-f615-485c-bea4-b3c779cb1e4e',
      name: 'Odd Inicial - Match Odds back visitante',
      type: 'integer',
      jsonMap: 'initialOdds[\'match odds-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '13ce47d7-e79d-4cd9-ba66-d36ddb7f7c7d',
      name: 'Odd Inicial - Match Odds lay visitante',
      type: 'integer',
      jsonMap: 'initialOdds[\'match odds-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '48473edf-4655-43a5-9f6b-779e98e517ec',
      name: 'Odd Inicial - Match Odds back empate',
      type: 'integer',
      jsonMap: 'initialOdds[\'match odds-3\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ee45bb90-c0c1-4c08-8677-37fb3a1bc64e',
      name: 'Odd Inicial - Match Odds lay empate',
      type: 'integer',
      jsonMap: 'initialOdds[\'match odds-3\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '390cf3bd-aaa6-4b59-89aa-da60ab005d8a11',
      name: 'Odd Inicial - Half Time back casa',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f2e99bfa-1fa4-4e4a-a4f5-aae695ca8c1422',
      name: 'Odd Inicial - Half Time lay casa',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c23815d4-f615-485c-bea4-b3c779cb1e4e33',
      name: 'Odd Inicial - Half Time back visitante',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '13ce47d7-e79d-4cd9-ba66-d36ddb7f7c7d44',
      name: 'Odd Inicial - Half Time lay visitante',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '48473edf-4655-43a5-9f6b-779e98e517ec55',
      name: 'Odd Inicial - Half Time back empate',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time-3\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ee45bb90-c0c1-4c08-8677-37fb3a1bc64e66',
      name: 'Odd Inicial - Half Time lay empate',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time-3\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '64313754-8ad3-49ff-b8fe-3697ab8f9b2e',
      name: 'Odd Inicial - Under 0.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 0.5 goals-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5095af7b-15bc-48e5-b467-468a70601b64',
      name: 'Odd Inicial - Over 0.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 0.5 goals-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5e880f7e-fe0f-4440-ba3d-a2998fd24241',
      name: 'Odd Inicial - Under 0.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 0.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '2ed48c7b-188d-479c-9e88-6153175c6a5e',
      name: 'Odd Inicial - Over 0.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 0.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'e0d06609-46b0-4d1c-bbc2-afbd2be11d97',
      name: 'Odd Inicial - Under 1.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 1.5 goals-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '36a59dc5-12f9-486f-a7ae-6e3188ce4e3c',
      name: 'Odd Inicial - Over 1.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 1.5 goals-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'aa3e6ef1-0928-4f30-93b0-345180e5e036',
      name: 'Odd Inicial - Under 1.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 1.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '87a7b107-1979-44a9-9d56-34e96849beb4',
      name: 'Odd Inicial - Over 1.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 1.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f8cabd25-6db1-43f4-9c56-b1aa3a995365',
      name: 'Odd Inicial - Under 2.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 2.5 goals-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'eb9bfcac-7f1a-46d7-a091-13fc1d2c16a3',
      name: 'Odd Inicial - Over 2.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 2.5 goals-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5fcff293-cc46-42d7-83ee-b379db197e7a',
      name: 'Odd Inicial - Under 2.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 2.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd7e5aa17-5f00-46ac-a582-4034b8382f32',
      name: 'Odd Inicial - Over 2.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 2.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '8d0d334d-3dd6-4f91-ae51-466c65d656ba',
      name: 'Odd Inicial - Under 3.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 3.5 goals-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '5a62b798-c712-4f40-a828-eae89c167872',
      name: 'Odd Inicial - Over 3.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 3.5 goals-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '60c59d66-b1a0-4171-88cb-e4ab89bc39b2',
      name: 'Odd Inicial - Under 3.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 3.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '01c095bf-a21f-4478-b6ca-b2b7ff059be7',
      name: 'Odd Inicial - Over 3.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 3.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '31a41d91-d40a-45fe-b5d6-9acd69e46ff9',
      name: 'Odd Inicial - Under 4.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 4.5 goals-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'dbb85831-5735-4b19-8a0b-2bde235f941e',
      name: 'Odd Inicial - Over 4.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 4.5 goals-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '2dbf06ad-8cda-4f22-864c-1eb78ad66048',
      name: 'Odd Inicial - Under 4.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 4.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'f2e6781e-e22d-4dd7-9acc-6d462428901f',
      name: 'Odd Inicial - Over 4.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 4.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '0b398202-3d1e-4606-b2e3-ae27fe87ce46',
      name: 'Odd Inicial - Under 5.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 5.5 goals-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '1a89e15b-7136-4a14-a28c-57221d0180d9',
      name: 'Odd Inicial - Over 5.5 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 5.5 goals-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '261e1ebf-79a7-43e7-8944-04fa94d5f8cc',
      name: 'Odd Inicial - Under 5.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 5.5 goals-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'bdabe412-7143-42b2-aef3-8dc6ac15bef3',
      name: 'Odd Inicial - Over 5.5 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'over/under 5.5 goals-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '288d696d-4ea4-4c58-bd80-4cebd2e75efc',
      name: 'Odd inicial - CS 0x0 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '20436b26-f52c-4d65-ac75-e2f784ceaad1',
      name: 'Odd inicial - CS 0x0 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '83e81827-516a-49ef-a497-8dc97a7c6be9',
      name: 'Odd inicial - CS 0x1 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '49b73fb1-7d66-4f1a-94dc-cb00c38980a0',
      name: 'Odd inicial - CS 0x1 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '2a93090c-2e9d-4235-9f3b-e76a0ae3fdf1',
      name: 'Odd inicial - CS 0x2 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-3\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'd72123f5-9a13-44f7-8475-3acff1b72729',
      name: 'Odd inicial - CS 0x2 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-3\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'ce59a606-9512-41e8-be90-06cba3ce2e14',
      name: 'Odd inicial - CS 0x3 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-4\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '66f2fdb4-2679-435a-afe5-8c5bde7e7feb',
      name: 'Odd inicial - CS 0x3 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-4\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c160fd7d-51f9-465e-8daf-9f3639b97110',
      name: 'Odd inicial - CS 1x0 back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-5\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4f8990b4-f82b-4801-a867-5c17718ca01a',
      name: 'Odd inicial - CS 1x0 lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-5\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: 'c5887c6a-3297-4200-ae61-c6395516c87f111',
      name: 'Odd inicial - CS 1x1 FT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-6\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '99e4331e-17ad-4827-bb96-cd8814ebae1222',
      name: 'Odd inicial - CS - 1x1 FT Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-6\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'f2de9455-f1b5-4b97-8623-890f5e7d93b0333',
      name: 'Odd inicial - CS 1x2 FT Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-7\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '6d13a8db-13e9-40c0-94ef-69d2dbae20a3444',
      name: 'Odd inicial - 1x2 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-7\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '73d2d790-96e2-4e36-a07b-8d4fc99609765555',
      name: 'Odd inicial - 1x3 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-8\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '0ea0a3c5-7e28-4aa9-a19e-2240a0fbd1f6666',
      name: 'Odd inicial - 1x3 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-8\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '21db576a-5020-4f16-b28e-d6d6d68334c1777',
      name: 'Odd inicial - 2x0 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-9\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'cbe6f27f-da6d-4ea1-a2bc-10c10ce87a36888',
      name: 'Odd inicial - 2x0 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-9\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '5fec1c22-d2a8-4d5f-8fd6-37f55abc944d999',
      name: 'Odd inicial - 2x1 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-10\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '97e5bbb0-a394-44c6-86f8-34e8d27c68491010',
      name: 'Odd inicial - 2x1 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-10\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'bd64e1d9-d648-472e-871a-ac4545c558a61111',
      name: 'Odd inicial - 2x2 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-11\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '84c71697-ee61-4a61-85fe-10b5e1931bd51212',
      name: 'Odd inicial - 2x2 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-11\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'ff6b3558-4475-440c-8a2d-6f1bbcca685d1313',
      name: 'Odd inicial - 2x3 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-12\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '49dd24f6-e24a-4638-95a1-dd0ea44fba521414',
      name: 'Odd inicial - 2x3 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-12\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '9178fa0d-540e-43ec-b158-2171cdc84a381515',
      name: 'Odd inicial - 3x0 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-13\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'd0559b97-0321-4137-b9c3-c1f85cba460d1616',
      name: 'Odd inicial - 3x0 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-13\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '62c45a0c-5a9d-45ce-9d52-e64743cd73451717',
      name: 'Odd inicial - 3x1 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-14\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '02296783-35fb-4030-999a-744fa96e56241818',
      name: 'Odd inicial - 3x1 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-14\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'bb4a59f8-c35f-4fd9-b37b-53fae926eef01919',
      name: 'Odd inicial - 3x2 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-15\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '804da299-583f-494b-9248-107ca46881ad2020',
      name: 'Odd inicial - 3x2 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-15\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '7178126c-d15f-436c-ab0f-c5da064b1adb2121',
      name: 'Odd inicial - 3x3 FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-16\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '505610f3-cd49-4fbd-9247-9b4f17e918ed2222',
      name: 'Odd inicial - 3x3 FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-16\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'e298716c-9c4b-4d3f-8ee1-dae803432dcd',
      name: 'Odd inicial - Win Visitado FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-17\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '5cb12bb4-525a-46eb-80eb-76621f3190742323',
      name: 'Odd inicial - Win Visitado FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-17\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'e9f2ec92-45e1-40e7-824a-3b4bc5bde2ce2424',
      name: 'Odd inicial - Win Visitante FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-18\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'b0fee321-cb9c-40fb-8191-571f9b76baac2525',
      name: 'Odd inicial - Win Visitante FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-18\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '12d6e19e-32f9-49ce-b909-dc0f8aaa81f32626',
      name: 'Odd inicial - Outro Empate FT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-19\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'eb30aed9-a7b1-4f6c-ac20-3f8efc233f1f2727',
      name: 'Odd inicial - Outro Empate FT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'correct score-19\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231',
      name: 'Odd inicial - CS 0x0 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-1\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122',
      name: 'Odd inicial - CS 0x0 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-1\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312233',
      name: 'Odd inicial - CS 1x1 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-2\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231234',
      name: 'Odd inicial - CS 1x1 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-2\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122335',
      name: 'Odd inicial - CS 2x2 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-3\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312346',
      name: 'Odd inicial - CS 2x2 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-3\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231223357',
      name: 'Odd inicial - CS 1x0 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-4\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123468',
      name: 'Odd inicial - CS 1x0 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-4\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312233579',
      name: 'Odd inicial - CS 2x0 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-5\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231234680',
      name: 'Odd inicial - CS 2x0 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-5\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122335792',
      name: 'Odd inicial - CS 2x1 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-6\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312346803',
      name: 'Odd inicial - CS 2x1 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-6\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231223357923',
      name: 'Odd inicial - CS 0x1 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-7\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123468034',
      name: 'Odd inicial - CS 0x1 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-7\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312233579234',
      name: 'Odd inicial - CS 0x2 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-8\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231234680345',
      name: 'Odd inicial - CS 0x2 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-8\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123122335792345',
      name: 'Odd inicial - CS 1x2 HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-9\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd12312346803456',
      name: 'Odd inicial - CS 1x2 HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-9\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd1231223357923457',
      name: 'Odd inicial - CS Outro HT back',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-10\'].back',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: 'c5887c6a-31235asdasd123123468034568',
      name: 'Odd inicial - CS Outro HT lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'half time score-10\'].lay',
      dataType: 'market odds',
      access: [9, 15]
    }, {
      id: '4fasdasd1238990basdad123asd1237718ca01a',
      name: 'Odd inicial - BTTS sim back',
      type: 'integer',
      jsonMap: 'initialOdds[\'both teams to score?-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990basdad123asd1237718ca01a2',
      name: 'Odd inicial - BTTS sim lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'both teams to score?-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990basdad123asd1237718ca01a3',
      name: 'Odd inicial - BTTS não back',
      type: 'integer',
      jsonMap: 'initialOdds[\'both teams to score?-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990basdad123asd1237718ca01a4',
      name: 'Odd inicial - BTTS não lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'both teams to score?-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12311',
      name: 'Odd inicial - Under 0.5 HT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 0.5-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12312',
      name: 'Odd inicial - Under 0.5 HT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 0.5-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12313',
      name: 'Odd inicial - Over 0.5 HT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 0.5-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12314',
      name: 'Odd inicial - Over 0.5 HT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 0.5-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12315',
      name: 'Odd inicial - Under 1.5 HT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 1.5-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12316',
      name: 'Odd inicial - Under 1.5 HT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 1.5-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12317',
      name: 'Odd inicial - Over 1.5 HT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 1.5-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12318',
      name: 'Odd inicial - Over 1.5 HT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 1.5-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd12319',
      name: 'Odd inicial - Under 2.5 HT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 2.5-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd123110',
      name: 'Odd inicial - Under 2.5 HT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 2.5-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd123111',
      name: 'Odd inicial - Over 2.5 HT - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 2.5-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd1238990baadasd1123asd123112',
      name: 'Odd inicial - Over 2.5 HT - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'first half goals 2.5-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389asdjhadjkhkj123kjhasd8761231',
      name: 'Odd inicial - Chance dupla - Casa ou empate - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'double chance-1\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389asdjhadjkhkj123kjhasd8761232',
      name: 'Odd inicial - Chance dupla - Casa ou empate - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'double chance-1\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389asdjhadjkhkj123kjhasd8761233',
      name: 'Odd inicial - Chance dupla - Empate ou visitante - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'double chance-2\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389asdjhadjkhkj123kjhasd8761234',
      name: 'Odd inicial - Chance dupla - Empate ou visitante - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'double chance-2\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389asdjhadjkhkj123kjhasd8761235',
      name: 'Odd inicial - Chance dupla - Casa ou visitante - Back',
      type: 'integer',
      jsonMap: 'initialOdds[\'double chance-3\'].back',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }, {
      id: '4fasdasd12389asdjhadjkhkj123kjhasd8761236',
      name: 'Odd inicial - Chance dupla - Casa ou visitante - Lay',
      type: 'integer',
      jsonMap: 'initialOdds[\'double chance-3\'].lay',
      dataType: 'market odds',
      access: [3, 4, 5, 6, 7, 8, 9, 15, 111, 112]
    }], this.marketInputs, this.specialInputs, this.indicatorsInputs, this.arnoldInputs);
    this.listSpeacialInputs = ['includesTeam'];
  }

  return Utils;
}();

var utilsKeys = new Utils();
/* eslint-disable no-eval */

var Helpers =
/** @class */
function () {
  function Helpers() {}

  Helpers.parseConditions = function (conditions) {
    try {
      var inputsToChangeValue_1 = ['ID time casa', 'ID time visitante', 'ID time'];
      var mapValidate_1 = [{
        name: 'maior que',
        value: '>'
      }, {
        name: 'maior igual a',
        value: '>='
      }, {
        name: 'menor que',
        value: '<'
      }, {
        name: 'menor igual a',
        value: '<='
      }, {
        name: 'igual a',
        value: '=='
      }, {
        name: '=',
        value: '=='
      }];
      var newConditions = conditions.map(function (el) {
        var newObj = el;
        var findInDataForSearch = utilsKeys.methodsInputs.find(function (el2) {
          var _a, _b;

          return ((_a = el2.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_b = newObj.condition) === null || _b === void 0 ? void 0 : _b.toLowerCase());
        }) || null;
        var findValidate = mapValidate_1.find(function (el3) {
          var _a, _b;

          return ((_a = el3.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === ((_b = newObj.validate) === null || _b === void 0 ? void 0 : _b.toLowerCase());
        }) || null;
        newObj.jsonMap = findInDataForSearch ? findInDataForSearch.jsonMap : null;
        newObj.dataType = findInDataForSearch ? findInDataForSearch.dataType : null;
        newObj.validate = findValidate ? findValidate.value : newObj.validate;

        if (newObj.type === utilsKeys.appKeys.relative) {
          var findInDataForSearch2 = utilsKeys.methodsInputs.find(function (el2) {
            return el2.name.toLowerCase() === newObj.value.toLowerCase();
          });
          newObj.jsonMap2 = findInDataForSearch2 ? findInDataForSearch2.jsonMap : null;
        }

        if (inputsToChangeValue_1.includes(newObj.condition)) {
          if (newObj.value && newObj.value.includes('-')) {
            // eslint-disable-next-line prefer-destructuring
            newObj.value = newObj.value.split(' - ')[0];
          }
        }

        return newObj;
      });
      return newConditions;
    } catch (e) {
      console.log('parseConditions error', e.stack);
      return [];
    }
  };
  /**
   *
   *
   * @static
   * @param {MainResumeObj} game
   * @param {MethodConditions[]} conditions Condições do metodo
   * @param {number} 1.Todas condições verdadeiras(E)/2.Uma das condições é verdadeira(OU)
   * @returns {boolean}
   * @memberof Helpers
   */


  Helpers.compareGameWithMethod = function (game, conditions, methodType) {
    if (methodType === void 0) {
      methodType = 1;
    }

    try {
      var compare_1 = [];
      conditions.forEach(function (el) {
        if (el.dataType) {
          var condition = el.validate;
          var value = el.value,
              type = el.type; // Special Inputs

          if (utilsKeys.listSpeacialInputs.includes("" + el.jsonMap)) {
            if (el.jsonMap === 'includesTeam') {
              if (condition === '==') {
                var result = game.teams.includes(value);
                compare_1.push(result);
              }

              if (condition === '!=') {
                var result = !game.teams.includes(value);
                compare_1.push(result);
              }
            }
          } // Relativo


          if ((type === utilsKeys.appKeys.relative || type === utilsKeys.appKeys.relative_old) && !utilsKeys.listSpeacialInputs.includes("" + el.jsonMap)) {
            if (condition !== '==') {
              var valueInGame = parseFloat(eval("game." + el.jsonMap));
              var valueInGame2 = parseFloat(eval("game." + el.jsonMap2));
              var result = eval(valueInGame + " " + condition + " " + valueInGame2); // Plus operator

              if (el.plusOperator && el.plusValue) {
                result = eval(valueInGame + " " + condition + " (" + valueInGame2 + " " + el.plusOperator + " " + el.plusValue + ")");
              }

              compare_1.push(result);
            }

            if (condition === '==') {
              var valueInGame = eval("game." + el.jsonMap);
              var valueInGame2 = eval("game." + el.jsonMap2);

              if (typeof valueInGame === 'string') {
                valueInGame = valueInGame.toLowerCase();
              }

              if (typeof valueInGame2 === 'string') {
                valueInGame2 = valueInGame2.toLowerCase();
              } // eslint-disable-next-line eqeqeq


              var result = valueInGame == valueInGame2; // Plus operator

              if (el.plusOperator && el.plusValue) {
                result = eval(valueInGame + " == (" + valueInGame2 + " " + el.plusOperator + " " + el.plusValue + ")");
              }

              compare_1.push(result);
            }
          } // Absoluto


          if ((type === utilsKeys.appKeys.absolute || type === utilsKeys.appKeys.absolute_old) && !utilsKeys.listSpeacialInputs.includes("" + el.jsonMap)) {
            if (condition !== 'i' && condition !== '==' && condition !== '!=') {
              var valueInGame = parseFloat(eval("game." + el.jsonMap));
              var result = eval(valueInGame + " " + condition + " " + value); // Plus operator

              if (el.plusOperator && el.plusValue) {
                result = eval(valueInGame + " " + condition + " (" + value + " " + el.plusOperator + " " + el.plusValue + ")");
              }

              compare_1.push(result);
            }

            if (condition === 'i') {
              var valueInGame = eval("game." + el.jsonMap);
              var value1 = parseFloat(value.split(',')[0]);
              var value2 = parseFloat(value.split(',')[1]);
              var result = eval(valueInGame + " >= " + value1 + " && " + valueInGame + " <= " + value2);
              compare_1.push(result);
            }

            if (condition === '==') {
              var valueInGame = eval("game." + el.jsonMap);

              if (typeof valueInGame === 'string') {
                valueInGame = valueInGame.toLowerCase();
              } // Dar uma tratada aqui qnd for number
              // eslint-disable-next-line eqeqeq


              var result = valueInGame == value.toLowerCase(); // Plus operator

              if (el.plusOperator && el.plusValue) {
                result = eval(valueInGame + " == (" + value.toLowerCase() + " " + el.plusOperator + " " + el.plusValue + ")");
              }

              compare_1.push(result);
            }

            if (condition === '!=') {
              var valueInGame = eval("game." + el.jsonMap);

              if (typeof valueInGame === 'string') {
                valueInGame = valueInGame.toLowerCase();
              } // Dar uma tratada aqui qnd for number
              // eslint-disable-next-line eqeqeq


              var result = valueInGame != value.toLowerCase(); // Plus operator

              if (el.plusOperator && el.plusValue) {
                result = eval(valueInGame + " != (" + value.toLowerCase() + " " + el.plusOperator + " " + el.plusValue + ")");
              }

              compare_1.push(result);
            }
          }
        }
      });
      var finalResult = false;

      if (compare_1.length === 0) {
        finalResult = false;
        return finalResult;
      }

      if (methodType === 1) {
        if (!compare_1.includes(false)) {
          finalResult = true;
        }
      }

      if (methodType === 2) {
        if (compare_1.includes(true)) {
          finalResult = true;
        }
      }

      return finalResult;
    } catch (e) {
      return false;
    }
  };
  /**
   *
   *
   * @static
   * @param {MainResumeObj} game
   * @param {MethodConditions[]} conditions Condições do metodo
   * @param {number} 1.Todas condições verdadeiras(E)/2.Uma das condições é verdadeira(OU)
   * @returns {boolean}
   * @memberof Helpers
   */


  Helpers.compareGameWithMethodGroupSony = function (game, conditions) {
    var _this = this;

    try {
      var pConditions = JSON.parse(conditions);
      var compare_2 = [];
      var numbersGroups_1 = 0;

      if (!pConditions.length) {
        return false;
      }

      pConditions.forEach(function (el) {
        if (el.group && el.group.length) {
          numbersGroups_1 += 1;

          var parseConditions = _this.parseConditions(el.group);

          var result = _this.compareGameWithMethod(game, parseConditions, 1);

          compare_2.push(result);
        }
      });
      var finalResult = false;

      if (numbersGroups_1 <= 1) {
        if (!compare_2.includes(false)) {
          finalResult = true;
        }
      }

      if (numbersGroups_1 > 1) {
        if (compare_2.includes(true)) {
          finalResult = true;
        }
      }

      return finalResult;
    } catch (e) {
      return false;
    }
  };

  Helpers.showInputUser = function (inputId, userRole) {
    try {
      var findInputs = utilsKeys.methodsInputs.find(function (el) {
        return el.id === inputId;
      });

      if (!findInputs) {
        return false;
      }

      return findInputs.access.includes(userRole);
    } catch (e) {
      return false;
    }
  };

  Helpers.showInputAccessUser = function (inputId, userInputRole) {
    var _a;

    try {
      var findInputs = utilsKeys.methodsInputs.find(function (el) {
        return el.id === inputId;
      });

      if (!findInputs) {
        return false;
      }

      return ((_a = findInputs === null || findInputs === void 0 ? void 0 : findInputs.inputAccess) === null || _a === void 0 ? void 0 : _a.includes(userInputRole)) || false;
    } catch (e) {
      return false;
    }
  };

  return Helpers;
}();

var index = {
  parseConditions: Helpers.parseConditions,
  compareGameWithMethod: Helpers.compareGameWithMethod,
  showInputUser: Helpers.showInputUser,
  showInputAccessUser: Helpers.showInputAccessUser,
  compareGameWithMethodGroupSony: Helpers.compareGameWithMethodGroupSony,
  utils: {
    appKeys: utilsKeys.appKeys,
    inputTypes: utilsKeys.inputTypes,
    methodsInputs: utilsKeys.methodsInputs
  }
};
export default index;